import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';
import bindModel from '../../../common/bindModel.js';
import { takeRight } from 'lodash';
import { isHexColor6 } from './../../../common/validate.js';

export default class ModalUpdateCompetition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            realGifts: [],
            categories: [],
            cups: [],
            avas: [],
            commentFrames: [],
            roomEntryEffects: [],
            userDecorations: [],
            personalCards: [],
            medalDecoration: [],
            frameDecoration: [],
            singEffects: [],
            competition: null,
            previewImg: null,
            loading: false,
            deepARStickerModels: [],
            choiceStickerDeepAr: [],
            countDeepAr: 1,
            strDeepAr: "",
            preValue: null,
            choiceHashtag: [],
            models: [],
            strHashtag: "",
            countHashtag: 1,
            leaderboardKinds: [],
            // KF-28944 Sự kiện Giữ Chuỗi — cấu hình riêng, KHÔNG gộp vào payload TheVoice.
            streak: {
                liveRoomId: '',
                posterUid: '',
                milestoneLen: '3',
                giftId: 'HOA CA',
                dailyPosts: [],
                saving: false,
                loadedForId: null,
            },
            // BXH Bài Thu — cấu hình riêng qua /game/web/recording-contest/config.
            recordingContest: {
                levelCheckEnabled: false,
                minLevel: '',
                maxLevel: '',
                topSize: '10',
                saving: false,
                loadedForId: null,
            },
        }
        this.getAllRealGift = this.getAllRealGift.bind(this);
        this.getCategories = this.getCategories.bind(this);
        this.getCups = this.getCups.bind(this);
        this.getAvas = this.getAvas.bind(this);
        this.getDecorationItemType = this.getDecorationItemType.bind(this);
        this.loadItem = this.loadItem.bind(this);
        this.getLeaderboardKinds = this.getLeaderboardKinds.bind(this);

        this.uploadAnimationToS3 = this.uploadAnimationToS3.bind(this);
        this.uploadAnimationToS4 = this.uploadAnimationToS4.bind(this);
        this.uploadAnimationToS5 = this.uploadAnimationToS5.bind(this);

        this.showImgPreview = this.showImgPreview.bind(this);
        this.saveCompetition = this.saveCompetition.bind(this);
        this.handleChoiceDeepAr = this.handleChoiceDeepAr.bind(this);
        this.handleChoiceHashtag = this.handleChoiceHashtag.bind(this);
        this.handleShowChoice = this.handleShowChoice.bind(this);
        this.handleShowHashtag = this.handleShowHashtag.bind(this);

        this.handleDeleteDeepAr = this.handleDeleteDeepAr.bind(this);
    }
    componentWillReceiveProps(props) {
        console.table(this.state.competition);

        $("#choiceStickerDeepAr").html("");
        $("#choiceHashtag").html("");

        setTimeout(() => {
            const { strDeepAr,strHashtag } = this.state;
            let competition = props.competition;
            // Cuộc thi custom (vd BXH Bài Thu) từ server có thể thiếu giftTheVoiceRound2,
            // trong khi render truy cập thẳng [0]..[3] — pad đủ 5 phần tử như lúc tạo mới.
            if (competition) {
                if (!Array.isArray(competition.giftTheVoiceRound2)) {
                    competition.giftTheVoiceRound2 = [];
                }
                while (competition.giftTheVoiceRound2.length < 5) {
                    competition.giftTheVoiceRound2.push({});
                }
            }
            if (competition && !competition.backgroundCode) {
                competition.backgroundCode = {
                    backgroundCodeContest: '',
                    backgroundCodeRule: '',
                    backgroundCodeRound1: '',
                    backgroundCodeRound2: '',
                    backgroundCodeRound3: '',
                    backgroundCodeRank: '',
                    backgroundCodeButton: '',
                    backgroundCodeFooter: '',
                }
            }

            let number = 1;
            let arr = [];
            let array = [];
            if (competition && competition.stickersDeepAr && competition.stickersDeepAr.length > 0) {
                for (let i = 0; i < competition.stickersDeepAr.length; i = i + 1) {
                    arr.push(competition.stickersDeepAr[i]._id);
                }
            }
            if (competition && competition.stickersDeepAr && competition.stickersDeepAr.length > 0) {
                for (let i = 0; i < competition.stickersDeepAr.length; i = i + 1) {
                    let id = "selectDeepAr" + number;
                    $("#choiceStickerDeepAr").append(
                        `<div class="row">
                        <div class="col-6">
                        <select class="form-control" name="selectDeepAr${number}" id="selectDeepAr${number}">
                        ${strDeepAr}
                        </select>
                        </div>
                        <div class="col-6">
                        <button class="btn btn-danger" id="deleteDeepAr${number}" name=${number}>Xóa</button>
                        </div>
                        </div>`)

                    $(`#selectDeepAr${number}`).val(competition.stickersDeepAr[i]._id).change();
                    let idC = 0;
                    $(`#selectDeepAr${number}`).on('focusin', function () {
                        console.log("Saving value " + $(this).val());
                        idC = $(this).val();
                    });
                    $(`#selectDeepAr${number}`).on("change", (e) => {
                        this.handleChoiceDeepAr(e, idC)
                    })

                    $(`#deleteDeepAr${number}`).on("click", () => {
                        let element = $(`#${id}`);
                        let valueOfElement = element.val();
                        let index = arr.indexOf(valueOfElement)
                        if (index >= 0) {
                            arr.splice(index, 1);
                        }
                        this.setState({
                            choiceStickerDeepAr: arr
                        })
                        element.val('-1').change();
                    })
                    number += 1;
                }
                this.setState({
                    countDeepAr: number
                })
            }
            if (competition && competition.hashtags && competition.hashtags.length > 0) {
                for (let i = 0; i < competition.hashtags.length; i ++) {
                    array.push(competition.hashtags[i]);
                }
            }
            console.log("arrayd",array);
            if (competition && competition.hashtags && competition.hashtags.length > 0) {
                for (let i = 0; i < competition.hashtags.length; i++) {
                    let id = "selectHashtag" + number;
                    $("#choiceHashtag").append(
                        `<div class="row">
                        <div class="col-6">
                        <select class="form-control" name="selectHashtag${number}" id="selectHashtag${number}">
                        ${strHashtag}
                        </select>
                        </div>
                        <div class="col-6">
                        <button class="btn btn-danger" id="deleteDeepAr${number}" name=${number}>Xóa</button>
                        </div>
                        </div>`)

                    $(`#selectHashtag${number}`).val(competition.hashtags[i]).change();
                    let idC = 0;
                    $(`#selectHashtag${number}`).on('focusin', function () {
                        console.log("Saving value10 " + $(this).val());
                        idC = $(this).val();
                    });
                    $(`#selectHashtag${number}`).on("change", (e) => {
                        this.handleChoiceHashtag(e, idC)
                    })

                    $(`#deleteDeepAr${number}`).on("click", () => {
                        let element = $(`#${id}`);
                        let valueOfElement = element.val();
                        let index = array.indexOf(valueOfElement)
                        if (index >= 0) {
                            array.splice(index, 1);
                        }
                        this.setState({
                            choiceHashtag: array
                        })
                        element.val('-1').change();
                    })
                    number += 1;
                }
                this.setState({
                    countHashtag: number
                })
            }
            if (competition && competition.stickersDeepAr && competition.stickersDeepAr.length == 0 || competition && competition.stickersDeepAr == null) {
                this.setState({
                    countDeepAr: 1
                })
            }

            // Xử lý hiển thị "Custom" nếu isCustom = true
            if (competition && competition.isCustom === true && competition.idEvent === "WebView") {
                competition.idEvent = "Custom";
            }

            this.setState({
                competition: competition,
                previewImg: props.previewImg,
                choiceStickerDeepAr: arr,
                choiceHashtag:array
            })
            // KF-28944: nạp cấu hình Giữ Chuỗi khi mở cuộc thi FIRE_STREAK đã có ID.
            if (competition && competition._id && competition.leaderboardKind === 'FIRE_STREAK'
                && this.state.streak.loadedForId !== competition._id) {
                this.loadStreakConfig(competition._id);
            }
            // Nạp cấu hình BXH Bài Thu khi mở cuộc thi RECORDING_CONTEST đã có ID.
            if (competition && competition._id && competition.leaderboardKind === 'RECORDING_CONTEST'
                && this.state.recordingContest.loadedForId !== competition._id) {
                this.loadRecordingContestConfig(competition._id);
            }
            // change day for event game
            if (competition && competition.timeEndRound1 && competition.timeEndRound2 && competition.idEvent == "GAME") {
                this.setState({
                    competition: {
                        ...competition, 
                        timeEndRound1: competition.timeEndRound2,
                    },
                })
            }
        })
    }
    loadItem() {
        axios.post(global.config.apiDomain + "/rest/deepAREffect/getAll")
            .then(res => {
                if (res.data.status == "OK") {
                    let str = `<option value=${-1}>Chọn hiệu ứng</option>`;
                    if (res.data && res.data.deepAREffectModels) {
                        res.data.deepAREffectModels.map((deepAr, index) => {
                            str += `<option value=${deepAr._id}>${deepAr.name}</option>`
                        })
                    }
                    console.log("deepAREffect", res.data)
                    this.setState({
                        deepARStickerModels: res.data.deepAREffectModels,
                        strDeepAr: str
                    })
                }
            })

    }

    loadHashtag() {
        axios.post(global.config.apiDomain + "/rest/hashtag/getAllHashtag")
            .then(res => {
                if (res.data.status == "OK") {
                    let str = `<option value=${-1}>Chọn hashtag</option>`;
                    if (res.data && res.data.models) {
                        res.data.models.map((model, index) => {
                            str += `<option value=${model.id}>${model.id}</option>`
                        })
                    }
                    this.setState({
                        models: res.data.models,
                        strHashtag: str
                    })
                }
            })

    }

    handleChoiceDeepAr(event, preValue) {
        const { choiceStickerDeepAr } = this.state;
        let idChoice = event.target.value;
        let arr = choiceStickerDeepAr;

        if (arr.includes(idChoice) && idChoice != -1) {
            toast.warning("Đã được chọn")
            event.target.value = preValue;
            return
        }

        if (idChoice != -1 && idChoice != 0) {
            arr.push(idChoice)
            this.setState({
                choiceStickerDeepAr: arr,
            })
        }
    }

  handleChoiceHashtag(event, preValue) {
    const { choiceHashtag } = this.state;
    let idChoice = event.target.value;
    console.log("idChoice",idChoice);
    let arr = choiceHashtag;
    console.log("arrarr",arr);

    if (arr.includes(idChoice)&& idChoice != -1) {
        toast.warning("Đã được chọn")
        event.target.value = preValue;
        return
    }
    if (idChoice != -1 && idChoice != 0) {

        arr.push(idChoice)
        this.setState({
            choiceHashtag: arr,
        })
    }
}


    handleDeleteDeepAr(event) {
        const { choiceStickerDeepAr } = this.state;
        let countDeepAr = event.target.name
        let element = $(`#${countDeepAr}`);
        let valueOfElement = element.val()

        let arr = choiceStickerDeepAr;
        let index = arr.indexOf(valueOfElement)
        if (index != -1) {
            arr.splice(index, 1);
        }

        this.setState({
            choiceStickerDeepAr: arr
        })
        element.val('-1').change();
    }
    handleShowChoice() {
        const { strDeepAr, countDeepAr, deepARStickerModels, choiceStickerDeepAr } = this.state;
        if (deepARStickerModels == null) {
            toast.warning("Không có sticker để hiển thị")
            return
        }

        let arr = deepARStickerModels;
        if (countDeepAr > arr.length) {
            if (countDeepAr == 1) {
                toast.warning("Không có sticker để hiển thị")
            } else {
                toast.warning("Đã hiển thị tối đa số lượng sticker")
            }
            return
        }

        $("#choiceStickerDeepAr").append(
            `<div class="row">
            <div class="col-6">
            <select class="form-control" name="selectDeepAr${countDeepAr}" id="selectDeepAr${countDeepAr}">
            ${strDeepAr}
            </select>
            </div>
            <div class="col-6">
            <button class="btn btn-danger" id="deleteDeepAr${countDeepAr}">Xóa</button>
            </div>
            </div>`)

        $(`#selectDeepAr${countDeepAr}`).on("change", this.handleChoiceDeepAr)
        $(`#deleteDeepAr${countDeepAr}`).on("click", () => {
            let element = $(`#selectDeepAr${countDeepAr}`);
            let valueOfElement = element.val();
            element.val('-1').change();
            let arr = choiceStickerDeepAr;
            let index = arr.indexOf(valueOfElement)
            if (index >= 0) {
                arr.splice(index, 1);
            }

            this.setState({
                choiceStickerDeepAr: arr
            })
        })
        let number = countDeepAr;
        this.setState({
            countDeepAr: number + 1
        })
    }

    handleShowHashtag() {
        const { strHashtag, countHashtag, models, choiceHashtag, preValue} = this.state;
        if (models == null) {
            toast.warning("Không có hashtag để hiển thị")
            return;
        }
        let arr = models;
        if (countHashtag > arr.length) {
            if (countHashtag === 1) {
                toast.warning("Không có hashtag để hiển thị")
            } else {
                toast.warning("Đã hiển thị tối đa số lượng hashtag")
            }
            return;
        }
        const dropdownId = `selectHashtag${countHashtag}`;

        $("#choiceHashtag").append(
            `<div class="row">
            <div class="col-6">
            <select class="form-control" name="${dropdownId}" id="${dropdownId}">
            ${strHashtag}
            </select>
            </div>
            <div class="col-6">
            <button class="btn btn-danger" id="deleteHashtag${countHashtag}" onclick="removeHashtag('${dropdownId}')">Xóa</button>
            </div>
            </div>`
        );

        // $(`#${dropdownId}`).on("change", () => this.handleChoiceHashtag);
        $(`#${dropdownId}`).on("change", this.handleChoiceHashtag)

        // $(`#${dropdownId}`).on("change", (event) => this.handleChoiceHashtag(event, preValue))
        $(`#deleteHashtag${countHashtag}`).on("click", () => {
            let element = $(`#${dropdownId}`);
            let valueOfElement = element.val();
            element.val('-1').change();
            let array = choiceHashtag;
            let index = array.indexOf(valueOfElement)
            if (index >= 0) {
                array.splice(index, 1);
            }

            this.setState({ 
                choiceHashtag: array
            })
        })
        
        let number = countHashtag;
        this.setState({
            countHashtag: number + 1
        });
    }

    componentDidMount() {
        this.getAllRealGift();
        this.getCategories();
        this.getCups();
        this.getAvas();
        this.getDecorationItemType();
        this.loadItem();
        this.loadHashtag();
        this.getLeaderboardKinds();

        $("#choiceStickerDeepAr").html("");
        $("#choiceHashtag").html("");
    }

    getCategories() {
        let modal = {
            isDelete: false
        };

        axios.post(global.config.apiDomain + '/rest/categories/getAllCategory', modal).then((res) => {
            this.setState({
                categories: res.data.categories
            });
        }).catch((error) => {
            console.log('error get categories ====');
            console.log(error);
        });
    }

    handleChange = (path, newValue) => {
        if (path !== 'competition.language') return;

        const selectedApp = newValue === 'vi' ? 'IKARA' : 'YOKARA';
        this.setState((state) => {
            const competition = state.competition || {};
            const categoryId = Number(competition.categoryId);
            const selectedCategory = (state.categories || []).find(
                (category) => Number(category.id) === categoryId
            );
            const categoryApp = selectedCategory && selectedCategory.app
                ? selectedCategory.app.toUpperCase()
                : 'YOKARA';

            return {
                competition: {
                    ...competition,
                    language: newValue,
                    // 0/1 là hai lựa chọn dùng chung. Chủ đề cụ thể phải thuộc đúng app.
                    categoryId: categoryId > 1 && categoryApp !== selectedApp
                        ? ''
                        : competition.categoryId,
                }
            };
        });
    }
    getCups() {
        axios.post(global.config.apiDomain + '/rest/gifts').then(res => {
            this.setState({
                cups: res.data,
            });
        });
    }
    getDecorationItemType() {
        let url = global.config.apiDomain + "/rest/decorationItemsType/getAllItems";
        axios.post(url)
            .then(res => {
                let decorations = [];
                let medal = [];
                for (let i = 0; i < res.data.decorationItemTypes.length; i++) {
                    if (res.data.decorationItemTypes[i].type == "FRAME") {
                        decorations.push(res.data.decorationItemTypes[i]);
                    }
                    if (res.data.decorationItemTypes[i].type == "MEDAL") {
                        medal.push(res.data.decorationItemTypes[i]);
                    }
                }
                this.setState({
                    frameDecoration: decorations,
                    medalDecoration: medal,
                })
            })
    }
    getLeaderboardKinds() {
        let url = global.config.apiDomain + "/game/web/leaderboard-kind";
        axios.get(url)
            .then(res => {
                if (res.data.status === "OK" && res.data.data && res.data.data.leaderboardKinds) {
                    this.setState({
                        leaderboardKinds: res.data.data.leaderboardKinds
                    });
                }
            })
            .catch(error => {
                console.log('Error get leaderboard kinds:', error);
            });
    }
    getAllRealGift() {
        let url = global.config.apiDomain + "/rest/realGift/getAllRealGift";
        axios.post(url)
            .then(res => {
                this.setState({
                    realGifts: res.data.models,
                })
            })
    }
    getAvas() {
        axios.post(global.config.apiDomain + '/web.v5.GetListShopItem').then(res => {
            let avatarFrameList = [];
            let userDecorationList = [];
            let commentFrameList = [];
            let personalCardList = [];
            let roomEntryEffectList = [];
            let singEffectsList = [];

            for (let i = 0; i < res.data.listItem.length; i++) {
                let type = res.data.listItem[i].type;
                switch (type) {
                    case "CommentFrame":
                        commentFrameList.push(res.data.listItem[i])
                        break;
                    case "RoomEntryEffect":
                        roomEntryEffectList.push(res.data.listItem[i])
                        break;
                    case "UserDecoration":
                        userDecorationList.push(res.data.listItem[i])
                        break;
                    case "PersonalCard":
                        personalCardList.push(res.data.listItem[i])
                        break;
                    case "SingEffect":
                        singEffectsList.push(res.data.listItem[i])
                        break;
                    default: avatarFrameList.push(res.data.listItem[i])
                }
            }
            this.setState({
                ...this.state,
                avas: avatarFrameList,
                commentFrames: commentFrameList,
                roomEntryEffects: roomEntryEffectList,
                userDecorations: userDecorationList,
                personalCards: personalCardList,
                singEffects: singEffectsList,
            });
        })
    }

    saveCompetition() {
        const { choiceStickerDeepAr, deepARStickerModels, choiceHashtag, models } = this.state;
        let obj = { ...this.state.competition };

        // Xử lý flag isCustom khi Custom được chọn
        if (obj.idEvent === "Custom") {
            obj.isCustom = true;
            obj.idEvent = "WebView";
        } else {
            obj.isCustom = false;
        }

        if (
            obj == undefined ||
            !obj.idEvent ||
            !obj.language ||
            !obj.miniBackgroundUrl ||
            !obj.name ||
            !obj.timeShowStart ||
            !obj.timeShowEnd
        ) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin CÀI ĐẶT CHÍNH');
        }

        if ((obj.idEvent == "TheVoice" || obj.idEvent == "GAME") && (
            !obj.imgUrl ||
            !obj.backgroundDialogUrl ||
            !obj.describe ||
            !obj.slogan ||
            !obj.theVoiceRuleFull.titleTime ||
            !obj.theVoiceRuleFull.detailTime ||
            !obj.theVoiceRuleFull.titleRule ||
            !obj.theVoiceRuleFull.detailRule ||
            !obj.theVoiceRuleFull.titleOther ||
            !obj.theVoiceRuleFull.detailOther ||
            !obj.numRewardRound2 ||
            !obj.backgroundCode ||
            !obj.backgroundCode.backgroundCodeContest ||
            !obj.backgroundCode.backgroundCodeRule ||
            !obj.backgroundCode.backgroundCodeRound1 ||
            !obj.backgroundCode.backgroundCodeRank ||
            !obj.backgroundCode.backgroundCodeButton ||
            !obj.backgroundCode.backgroundCodeFooter
        )) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin CÀI ĐẶT CHÍNH cho TheVoice và GAME');
        } 

        if (obj.idEvent == "TheVoice" && (
            !obj.typePermissionAccept ||
            !obj.typeRecordingAccept ||
            !obj.typeRecordingMedia
        )) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin CÀI ĐẶT CHÍNH cho TheVoice');
        } 

        if (obj.idEvent == "RoomEvent" && (
            !obj.timeStart ||
            !obj.timeEnd ||
            !obj.largeBackgroundUrl ||
            !obj.isSendNotification
        )) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin CÀI ĐẶT CHÍNH cho Sự Kiện Phòng');
        }else{
            if(obj.isSendNotification){
                if(!obj.timeSendNotification){
                    return toast.error('Nhập thời gian thông báo cho Sự Kiện Phòng');
                }
            }
            obj.timeStart = Date.parse(obj.timeStart);
            obj.timeEnd = Date.parse(obj.timeEnd);
            obj.timeSendNotification = Date.parse(obj.timeSendNotification);
        }


        if ( obj.idEvent == "TheVoice" && 
            (!obj.timeStartRound1 ||
            !obj.timeEndRound1 ||
            !obj.timeEndRound2 ||
            !obj.limitRecordingRound1 ||
            !obj.limitRecordingRound2 ||
            !obj.maxNumMediaOneUse ||
            !obj.minLevelExaminer ||
            !obj.maxMediaForOneExaminer ||
            !obj.maxExaminerForOneMedia ||
            !obj.minNumMark ||
            !obj.canApplyExaminer ||
            (obj.canApplyExaminer != '0' && obj.canApplyExaminer != '1'))
        ) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin VÒNG THI cho TheVoice');
        } 

        if (obj.timeStartRound1 > obj.timeEndRound1) {
            return toast.error('Thời gian bắt đầu cuộc thi phải trước thời gian kết thúc');
        }

        if (obj.idEvent == "TheVoice") {
            obj.timeStartRound1 = Date.parse(obj.timeStartRound1);
            obj.timeEndRound1 = Date.parse(obj.timeEndRound1);
            obj.timeEndRound2 = Date.parse(obj.timeEndRound2);
        } else if (obj.idEvent == "GAME" || obj.idEvent == "WebView") {
            let timeEndRound1 = obj.timeEndRound1;
            obj.timeStartRound1 = Date.parse(obj.timeStartRound1);
            obj.timeEndRound1 = obj.timeStartRound1;
            obj.timeEndRound2 = Date.parse(timeEndRound1);
        }
        const hasInvalidHexColor = (colors = []) =>
            colors.some(c => c && !isHexColor6(c));

        if (hasInvalidHexColor([
            obj.backgroundCode?.backgroundCodeContest,
            obj.backgroundCode?.backgroundCodeRule,
            obj.backgroundCode?.backgroundCodeRound1,
            obj.backgroundCode?.backgroundCodeRound2,
            obj.backgroundCode?.backgroundCodeRound3,
            obj.backgroundCode?.backgroundCodeRank,
            obj.backgroundCode?.backgroundCodeButton,
            obj.backgroundCode?.backgroundCodeFooter,
        ])) {
            toast.error("Không thể lưu! Mã màu phải đúng dạng #FFFFFF");
            return;
        }
        if (obj.isCustom == true &&
            (
                !obj.imgUrl ||
                !obj.ruleImgUrl ||
                !obj.markIcon ||
                !obj.backgroundCode.backgroundCodeContest ||
                !obj.backgroundCode.backgroundCodeFooter ||
                !obj.leaderboardKind
            )

        ) {
            return toast.error('Nhập đầy đủ thông tin VÒNG THI cho Custom');
        }

        obj.timeShowStart = Date.parse(obj.timeShowStart);
        obj.timeShowEnd = Date.parse(obj.timeShowEnd);

        let arrSticker = [];
        choiceStickerDeepAr && choiceStickerDeepAr.map((choiceSticker, index) => {
            deepARStickerModels && deepARStickerModels.map((sticker, index) => {
                if (choiceSticker == sticker._id) {
                    arrSticker.push(sticker);
                }
            })
        })

        obj.stickersDeepAr = arrSticker;
        obj.categoryId = +obj.categoryId;
        if (obj.canApplyExaminer === '0') {
            obj.canApplyExaminer = false;
        } else if (obj.canApplyExaminer === '1') {
            obj.canApplyExaminer = true;
        }
       
        obj.hashtags = choiceHashtag;

        const myJSON = JSON.stringify(obj);
        console.log(myJSON);

        this.setState({
            loading: true
        });
        axios.post(global.config.apiDomain + '/rest/theVoiceV2/addOrUpdateTheVoice', myJSON, {
                headers: {
                    'Content-Type': 'application/json',
                },
             })
            .then(res => {
                this.setState({
                    loading: false
                });

                if (res.data.status == "OK") {
                    window.$("#modalUpdateCompetition").modal("hide");
                    this.props.resetList();
                    toast.success(res.data.message);
                } else {
                    toast.warning(res.data.message);
                }
            }, error => {
                this.setState({
                    loading: false
                });
                toast.error(error);
            })
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
    uploadAnimationToS3(event) {
        let target = event.target;
        if (target.files[0] && target.files[0].size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }

        this.setState({
            ...this.state,
            loading: true
        });

        let property = target.name;
        let competition = this.state.competition;
        let bucketName = "ikara-data/images/contests";
        let extension = target.files[0].name.split('.').pop().toLowerCase();
        let keyName = this.guid() + "." + extension;
        let contentType = "image/jpeg";
        if (extension === "png") {
            contentType = "image/png";
        } else if (extension === "gif") {
            contentType = "image/gif";
        } else if (extension === "jpg" || extension === "jpeg") {
            contentType = "image/jpeg";
        } else if (extension === "svga") {
            contentType = "image/svga";
        }

        let fileReader = new FileReader();
        let isError = false;
        fileReader.onload = function () {
            let fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });
                    this.setState({
                        competition: {
                            ...competition,
                            [property]: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                }.bind(this),
                error: function (error) {
                    this.setState({
                        loading: false
                    });
                    toast.error(error.response.data.message);
                    this.setState({
                        competition: {
                            ...competition,
                            [property]: ''
                        }
                    });
                    isError = true;
                }.bind(this)
            });
        }.bind(this);
        if (isError) {
            return;
        }
        fileReader.readAsArrayBuffer(target.files[0]);
    }
    uploadAnimationToS4(event) {
        let target = event.target;
        if (target.files[0].size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }

        this.setState({
            ...this.state,
            loading: true
        });

        let property = target.name;
        let competition = this.state.competition;
        let bucketName = "ikara-data/images/contests";
        let extension = target.files[0].name.split('.').pop().toLowerCase();
        let keyName = this.guid() + "." + extension;
        let contentType = "image/svga";
        if (extension == "png") contentType = "image/svga";

        let fileReader = new FileReader();
        fileReader.onload = function () {
            let fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });
                    this.setState({
                        competition: {
                            ...competition,
                            [property]: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                }.bind(this),
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }
    uploadAnimationToS5(event) {
        let target = event.target;
        if (target.files[0].size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }

        this.setState({
            ...this.state,
            loading: true
        });

        let property = target.name;

        let competition = this.state.competition;
        let bucketName = "ikara-data/images/contests";
        let extension = target.files[0].name.split('.').pop().toLowerCase();
        let keyName = this.guid() + "." + extension;
        let contentType = "image/svga";
        if (extension == "png") contentType = "image/svga";

        let fileReader = new FileReader();

        fileReader.onload = function () {
            let fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });
                    this.setState({
                        competition: {
                            ...competition,
                            [property]: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                }.bind(this),
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }

    showImgPreview(event) {
        const { cups, avas, roomEntryEffects, userDecorations, commentFrames, personalCards, frameDecoration, medalDecoration, realGifts, singEffects } = this.state;
        let tagId = event.target.value;
        let tagName = event.target.id;
        let type = tagName.slice(0, 3);
        let index = +tagName.substr(6, 1);
        let idAvatar = tagId;
        let items;

        switch (type) {
            case "ava":
                items = avas;
                break;
            case "roo":
                items = roomEntryEffects;
                break;
            case "prs":
                items = personalCards;
                break;
            case "cmt":
                items = commentFrames;
                break;
            case "udc":
                items = userDecorations;
                break;
            case "fra":
                items = frameDecoration;
                items.map((item) => {
                    if (item.name === tagId) {
                        idAvatar = item.id;
                    }
                })
                break;
            case "med":
                items = medalDecoration;
                items.map((item) => {
                    if (item.name === tagId) {
                        idAvatar = item.id;
                    }
                })
                break;
            case "rgf":
                items = realGifts;
                break;
            case "sin":
                items = singEffects;
                break;

            // cuối cùng là cups
            default: items = cups;
        }
        this.updateObjectToGiftTheVoiceRound2(items, idAvatar, type, index)

    }
    updateObjectToGiftTheVoiceRound2(listItem, tagId, type, index) {
        const { competition } = this.state;
        if (competition.giftTheVoiceRound2.length <= index) {
            return
        }

        let obj;
        for (let i = 0; i < listItem.length; i++) {
            const item = listItem[i];
            // huy hiệu + khung bài thu + cup + quà + quà thật
            if (item.id && item.id == tagId) {
                obj = item;
                break;
            }
            // shopItem
            if (item._id && item._id == tagId) {
                obj = item;
                break;
            }
        }
        if (obj === undefined) {
            return
        }

        switch (type) {
            case 'cup':
                competition.giftTheVoiceRound2[index - 1].cup = obj
                break;
            case 'gif':
                competition.giftTheVoiceRound2[index - 1].gift = obj
                break;
            case 'cmt':
                //cmt: comment frame
                competition.giftTheVoiceRound2[index - 1].commentFrame = obj;
                break;
            case 'prs':
                // prs: personal card
                competition.giftTheVoiceRound2[index - 1].personalCard = obj;
                break;
            case 'udc':
                //udc: user decoration
                competition.giftTheVoiceRound2[index - 1].userDecoration = obj;
                break;
            case 'roo':
                //roo: room entry effect
                competition.giftTheVoiceRound2[index - 1].roomEntryEffect = obj;
                break;
            case 'fra':
                //roo: room entry effect
                competition.giftTheVoiceRound2[index - 1].recordingFrame = obj;
                break;
            case 'med':
                //roo: room entry effect
                competition.giftTheVoiceRound2[index - 1].recordingMedal = obj;
                break;
            case 'ava':
                // ava: avatar frame
                competition.giftTheVoiceRound2[index - 1].avatarFrame = obj
                break;
            case 'sin':
                // sin: singer effect
                competition.giftTheVoiceRound2[index - 1].singEffects = obj
                break;
            case 'rgf':
                // rgf: realGift
                competition.giftTheVoiceRound2[index - 1].realGift = obj
                break;
        }
        this.setState({
            competition: competition
        })
    }
    // ================= KF-28944 Sự kiện Giữ Chuỗi (daily checkin) =================
    // Cấu hình lưu riêng qua /game/web/streak/config, KHÔNG gộp vào payload TheVoice.
    loadStreakConfig = (contestId) => {
        if (!contestId) return;
        axios.get(global.config.apiDomain + "/game/web/streak/" + contestId + "/config")
            .then(res => {
                const cfg = res && res.data ? res.data.data : null;
                if (!cfg) {
                    this.setState(s => ({ streak: { ...s.streak, loadedForId: contestId } }));
                    return;
                }
                this.setState(s => ({
                    streak: {
                        ...s.streak,
                        liveRoomId: cfg.liveRoomId != null ? String(cfg.liveRoomId) : '',
                        posterUid: cfg.posterUid != null ? String(cfg.posterUid) : '',
                        milestoneLen: cfg.milestoneLen != null ? String(cfg.milestoneLen) : '3',
                        giftId: cfg.giftId || 'HOA CA',
                        dailyPosts: Array.isArray(cfg.dailyPosts) ? cfg.dailyPosts : [],
                        loadedForId: contestId,
                    }
                }));
            })
            .catch(() => this.setState(s => ({ streak: { ...s.streak, loadedForId: contestId } })));
    };

    // Thời gian kết thúc cuộc thi: TheVoice dùng timeEndRound2 (ô Vòng 2); WebView/GAME chỉ có
    // ô "Thời gian kết thúc" = timeEndRound1 (lúc save mới map sang timeEndRound2).
    getStreakEndTime = () => {
        const c = this.state.competition || {};
        return c.idEvent === 'TheVoice' ? c.timeEndRound2 : (c.timeEndRound1 || c.timeEndRound2);
    };

    // Tự sinh bài đăng mỗi ngày trong khoảng [Thời gian bắt đầu, kết thúc] của cuộc thi.
    generateStreakDays = () => {
        const c = this.state.competition || {};
        const parse = (v) => {
            if (!v) return null;
            const d = new Date(v);
            return isNaN(d.getTime()) ? null : d;
        };
        const start = parse(c.timeStartRound1);
        const end = parse(this.getStreakEndTime());
        if (!start || !end) { toast.warning('Nhập Thời gian bắt đầu & kết thúc cuộc thi trước.'); return; }
        if (end < start) { toast.warning('Thời gian kết thúc phải sau thời gian bắt đầu.'); return; }
        const fmt = (d) => `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
        const byDate = {};
        (this.state.streak.dailyPosts || []).forEach(r => { if (r && r.eventDate) byDate[r.eventDate] = r; });
        const rows = [];
        const d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
        const last = new Date(end.getFullYear(), end.getMonth(), end.getDate());
        while (d <= last) {
            const ymd = fmt(d);
            rows.push(byDate[ymd] || { eventDate: ymd, caption: '', imageUrl: '' });
            d.setDate(d.getDate() + 1);
        }
        this.setState(s => ({ streak: { ...s.streak, dailyPosts: rows } }));
        toast.success('Đã tạo ' + rows.length + ' ngày. Nhập caption/ảnh rồi Lưu.');
    };

    updateStreakField = (field, value) => {
        this.setState(s => ({ streak: { ...s.streak, [field]: value } }));
    };
    updateStreakRow = (idx, field, value) => {
        this.setState(s => ({ streak: { ...s.streak, dailyPosts: s.streak.dailyPosts.map((r, i) => i === idx ? { ...r, [field]: value } : r) } }));
    };
    addStreakRow = () => {
        this.setState(s => ({ streak: { ...s.streak, dailyPosts: [...s.streak.dailyPosts, { eventDate: '', caption: '', imageUrl: '' }] } }));
    };
    removeStreakRow = (idx) => {
        this.setState(s => ({ streak: { ...s.streak, dailyPosts: s.streak.dailyPosts.filter((_, i) => i !== idx) } }));
    };
    // Đăng lại thủ công 1 bài điểm danh khi bị FAILED / kẹt POSTING (KF-28944).
    retryStreakPost = (idx) => {
        const row = (this.state.streak.dailyPosts || [])[idx];
        const contestId = this.state.competition && this.state.competition._id;
        if (!row || !row.eventDate || !contestId) { toast.error('Thiếu thông tin bài đăng để đăng lại.'); return; }
        if (!window.confirm('Đăng lại bài điểm danh ngày ' + row.eventDate + '?')) { return; }
        axios.post(global.config.apiDomain + '/game/web/streak/' + contestId + '/post/' + row.eventDate + '/retry')
            .then(() => {
                this.updateStreakRow(idx, 'postStatus', 'POSTING');
                toast.success('Đã gửi yêu cầu đăng lại. Vài giây sau mở lại cấu hình để xem trạng thái.');
            })
            .catch((error) => {
                const msg = (error && error.response && error.response.data && error.response.data.message) || 'Đăng lại thất bại.';
                toast.error(msg);
            });
    };

    // Upload ảnh bài đăng ngay tại dòng đó → set vào dailyPosts[idx].imageUrl (tái dùng /web.UploadFile).
    uploadStreakImage = (idx, event) => {
        const target = event.target;
        const file = target.files && target.files[0];
        if (!file) return;
        if (file.size > 10495760) { toast.error('Kích thước file phải dưới 10mb.'); return; }

        const extension = file.name.split('.').pop().toLowerCase();
        let contentType = 'image/jpeg';
        if (extension === 'png') contentType = 'image/png';
        else if (extension === 'gif') contentType = 'image/gif';
        else if (extension === 'webp') contentType = 'image/webp';

        const bucketName = 'ikara-data/images/contests';
        const keyName = this.guid() + '.' + extension;

        this.setState({ loading: true });
        const fd = new FormData();
        fd.append('file', file);
        fd.append('bucketName', bucketName);
        fd.append('objectKey', keyName);
        fd.append('contentType', contentType);
        $.ajax({
            url: global.config.apiDomain + '/web.UploadFile',
            data: fd,
            processData: false,
            contentType: false,
            type: 'POST',
            success: function () {
                this.setState({ loading: false });
                const url = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                this.updateStreakRow(idx, 'imageUrl', url);
                toast.success('Đã upload ảnh.');
            }.bind(this),
            error: function (error) {
                this.setState({ loading: false });
                const msg = (error && error.responseJSON && error.responseJSON.message) || 'Upload ảnh thất bại.';
                toast.error(msg);
            }.bind(this),
        });
        // reset input để chọn lại cùng file vẫn kích hoạt onChange
        target.value = '';
    };

    saveStreakConfig = () => {
        const c = this.state.competition || {};
        const contestId = c._id;
        if (!contestId) { toast.warning('Lưu cuộc thi trước (cần ID), rồi mở lại để cấu hình Giữ Chuỗi.'); return; }
        const st = this.state.streak;
        if (!st.liveRoomId || !st.posterUid || !st.giftId) { toast.error('Nhập Live Room ID / Poster UID / Gift ID.'); return; }
        const fmtDate = (v) => {
            if (!v) return undefined;
            const d = new Date(v);
            if (isNaN(d.getTime())) return undefined;
            return `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
        };
        const payload = {
            contestId: Number(contestId),
            liveRoomId: Number(st.liveRoomId),
            posterUid: Number(st.posterUid),
            milestoneLen: Number(st.milestoneLen) || 3,
            startDate: fmtDate(c.timeStartRound1),
            endDate: fmtDate(this.getStreakEndTime()),
            giftId: (st.giftId || '').trim(),
            language: c.language,
            dailyPosts: (st.dailyPosts || []).filter(r => r.eventDate && r.eventDate.trim() !== ''),
        };
        this.setState(s => ({ streak: { ...s.streak, saving: true } }));
        axios.post(global.config.apiDomain + '/game/web/streak/config', JSON.stringify(payload), { headers: { 'Content-Type': 'application/json' } })
            .then(res => {
                this.setState(s => ({ streak: { ...s.streak, saving: false } }));
                if (res.data && res.data.status === 'OK') {
                    const cfg = res.data.data;
                    toast.success(cfg && cfg.giftName ? ('Đã lưu Giữ Chuỗi. Quà: ' + cfg.giftName + ' (' + (cfg.giftValue != null ? cfg.giftValue : '?') + ')') : 'Đã lưu cấu hình Giữ Chuỗi.');
                } else {
                    toast.warning((res.data && res.data.message) || 'Lưu Giữ Chuỗi thất bại.');
                }
            }, error => {
                this.setState(s => ({ streak: { ...s.streak, saving: false } }));
                const msg = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Lưu Giữ Chuỗi thất bại (kiểm tra Gift ID).';
                toast.error(msg);
            });
    };
    // =============================================================================

    // ================= BXH Bài Thu (leaderboardKind = RECORDING_CONTEST) =================
    // Cấu hình lưu riêng qua /game/web/recording-contest/config, KHÔNG gộp vào payload TheVoice.
    loadRecordingContestConfig = (contestId) => {
        if (!contestId) return;
        axios.get(global.config.apiDomain + "/game/web/recording-contest/" + contestId + "/config")
            .then(res => {
                const cfg = res && res.data ? res.data.data : null;
                if (!cfg) {
                    this.setState(s => ({ recordingContest: { ...s.recordingContest, loadedForId: contestId } }));
                    return;
                }
                this.setState(s => ({
                    recordingContest: {
                        ...s.recordingContest,
                        levelCheckEnabled: cfg.levelCheckEnabled === true,
                        minLevel: cfg.minLevel != null ? String(cfg.minLevel) : '',
                        maxLevel: cfg.maxLevel != null ? String(cfg.maxLevel) : '',
                        topSize: cfg.topSize != null ? String(cfg.topSize) : '10',
                        loadedForId: contestId,
                    }
                }));
            })
            .catch(() => this.setState(s => ({ recordingContest: { ...s.recordingContest, loadedForId: contestId } })));
    };

    updateRecordingContestField = (field, value) => {
        this.setState(s => ({ recordingContest: { ...s.recordingContest, [field]: value } }));
    };

    saveRecordingContestConfig = () => {
        const c = this.state.competition || {};
        const contestId = c._id;
        if (!contestId) { toast.warning('Lưu cuộc thi trước (cần ID), rồi mở lại để cấu hình BXH Bài Thu.'); return; }

        const st = this.state.recordingContest;
        const topSize = Number(st.topSize);
        if (!topSize || topSize < 1 || topSize > 50) { toast.error('Số bài hiển thị phải từ 1 đến 50.'); return; }

        let minLevel = null;
        let maxLevel = null;
        if (st.levelCheckEnabled) {
            minLevel = Number(st.minLevel);
            maxLevel = Number(st.maxLevel);
            if (!minLevel || !maxLevel) { toast.error('Nhập Level bắt đầu và Level kết thúc.'); return; }
            if (minLevel > maxLevel) { toast.error('Level bắt đầu phải nhỏ hơn hoặc bằng Level kết thúc.'); return; }
        }

        const payload = {
            contestId: Number(contestId),
            levelCheckEnabled: st.levelCheckEnabled,
            minLevel: minLevel,
            maxLevel: maxLevel,
            topSize: topSize,
        };
        this.setState(s => ({ recordingContest: { ...s.recordingContest, saving: true } }));
        axios.post(global.config.apiDomain + '/game/web/recording-contest/config', JSON.stringify(payload), { headers: { 'Content-Type': 'application/json' } })
            .then(res => {
                this.setState(s => ({ recordingContest: { ...s.recordingContest, saving: false } }));
                if (res.data && res.data.status === 'OK') {
                    toast.success('Đã lưu cấu hình BXH Bài Thu.');
                } else {
                    toast.warning((res.data && res.data.message) || 'Lưu BXH Bài Thu thất bại.');
                }
            }, error => {
                this.setState(s => ({ recordingContest: { ...s.recordingContest, saving: false } }));
                const msg = error && error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Lưu BXH Bài Thu thất bại.';
                toast.error(msg);
            });
    };
    // ====================================================================================

    handleChangeIsSendNotification = (event) => {
        this.setState({
            competition: {
                ...this.state.competition,
                isSendNotification: event.target.checked,
                timeSendNotification: event.target.checked ? new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T") : ''
            }
        });
    }

    handleChangeIsHidden = (event) => {
        this.setState({
            competition: {
                ...this.state.competition,
                isHidden: event.target.checked,
            }
        });
    }

    render() {
        const model = bindModel(this);
        const { loading, competition, categories, frameDecoration, medalDecoration, cups, avas, userDecorations, personalCards, commentFrames, roomEntryEffects, realGifts, singEffects } = this.state;
        const selectedCategoryApp = competition && competition.language === 'vi' ? 'IKARA' : 'YOKARA';
        const visibleCategories = (categories || []).filter((category) => {
            // Chủ đề legacy chưa có app được backend quy ước là YOKARA.
            const categoryApp = category.app ? category.app.toUpperCase() : 'YOKARA';
            return categoryApp === selectedCategoryApp;
        });
        return (
            <div>
                <div className="modal fade" id="modalUpdateCompetition" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalCenterTitle">Cập nhật Cuộc thi</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="setting-tab" data-toggle="tab" href="#setting" role="tab" aria-controls="setting" aria-selected="true">Cài đặt chính</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="rounds-tab" data-toggle="tab" href="#rounds" role="tab" aria-controls="rounds" aria-selected="false">Cài đặt Vòng thi</a>
                                    </li>
                                    {competition && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME") ? 
                                        <>
                                            <li className="nav-item">
                                                <a className="nav-link" id="gift-tab" data-toggle="tab" href="#gift" role="tab" aria-controls="gift" aria-selected="false">Cài đặt quà</a>
                                            </li>
                                        </>
                                        : <></>
                                    }
                                </ul>

                                <div className="tab-content" id="myTabContent">
                                    {/* SETTING */}
                                    <div className="tab-pane fade show active" id="setting" role="tabpanel" aria-labelledby="setting-tab">
                                        <div>
                                            <p className="text-center">Chọn thể loại cuộc thi trước khi chọn các bước tiếp theo</p>
                                            <div id="idEvent" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Thể loại Cuộc Thi</label>
                                                </div>
                                                <div className="form-check col-9">
                                                    <select
                                                        className="form-control"
                                                        type="text"
                                                        name="idEvent"
                                                        {...model('competition.idEvent')} 
                                                        >
                                                        <option value="">Chọn</option>
                                                        <option value="GAME">GAME</option>
                                                        <option value="TheVoice">TheVoice</option>
                                                        <option value="WebGame">WebGame</option>
                                                        <option value="WebView">WebView</option>
                                                        <option value="RoomEvent">Sự Kiện Phòng</option>
                                                        <option value="Custom">Custom</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {competition && competition.idEvent == "RoomEvent" && (
                                                <div id="liveRoomUID" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>ID Phòng</label>
                                                    </div>
                                                    <div className="col-9">
                                                        <input type="text" className="form-control" name="liveRoomUID" {...model('competition.liveRoomUID')} />
                                                    </div>
                                                </div>
                                            )}
                                            <div id="language" className="row mb-2">
                                                <div className="col-3">
                                                    <label>App hiển thị</label>
                                                </div>
                                                <div className="form-check col-9">
                                                    <select
                                                        className="form-control"
                                                        type="text"
                                                        name="language"
                                                        {...model('competition.language')} >
                                                        <option value="">Chọn app</option>
                                                        <option value="vi">iKara (Vietnamese)</option>
                                                        <option value="en.yokara">Yokara (English)</option>
                                                        <option value="lo.okara">Okara - Laos</option>
                                                        <option value="mz.okara">Okara - Mozambique</option>
                                                        <option value="tl.okara">Okara - TimorLeste</option>
                                                        <option value="ht.okara">Okara - Haiti</option>
                                                    </select>
                                                    <small className="text-muted">Cuộc thi sẽ hiển thị trên app tương ứng (iKara = Tiếng Việt, Yokara = English).</small>
                                                </div>
                                            </div>

                                            <div id="miniBackgroundUrl" className="row mb-2">
                                                <div className="col-3">
                                                    <label>{competition && competition.idEvent == "RoomEvent" ? "Banner nhỏ sự kiện" : "Banner cuộc thi"}</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        name="miniBackgroundUrl"
                                                        onChange={this.uploadAnimationToS3}
                                                    />
                                                    <label className="custom-file-label ml-3 mr-3" htmlFor="miniBackgroundUrl">
                                                        Choose file
                                                    </label>
                                                </div>
                                            </div>

                                            <div id="smallBanner" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Banner nhỏ</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        name="smallBanner"
                                                        onChange={this.uploadAnimationToS3}
                                                    />
                                                    <label className="custom-file-label ml-3 mr-3" htmlFor="smallBanner">
                                                        Choose file
                                                    </label>
                                                </div>
                                            </div>

                                            {competition && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME") ?
                                                <>
                                                    <div id="imgUrl" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Hình chủ đề</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                name="imgUrl"
                                                                onChange={this.uploadAnimationToS4} />
                                                            <label className="custom-file-label ml-3 mr-3" htmlFor="imgUrl">Choose file</label>
                                                        </div>
                                                    </div>
                                                    <div id="backgroundDialogUrl" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Ảnh Dialog</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                name="backgroundDialogUrl"
                                                                onChange={this.uploadAnimationToS5}
                                                            />
                                                            <label className="custom-file-label ml-3 mr-3" htmlFor="backgroundDialogUrl">Choose file</label>
                                                        </div>
                                                    </div>
                                                </>
                                                : <></>
                                            }
                                         

                                            <div className="row mb-2">
                                                <div className="col-3">
                                                    <label></label>
                                                </div>
                                                <div className="col-3">
                                                    {(competition && competition.miniBackgroundUrl) ? (
                                                        <>
                                                            <label>{competition && competition.idEvent == "RoomEvent" ? "Banner Nhỏ" : "Banner"}</label>
                                                            <img src={competition.miniBackgroundUrl} />
                                                        </>
                                                    ) : ""}
                                                </div>

                                                <div className="col-3">
                                                    {(competition && competition.smallBanner) ? (
                                                        <>
                                                            <label>Banner nhỏ</label>
                                                            <img src={competition.smallBanner} />
                                                        </>
                                                    ) : ""}
                                                </div>

                                                {competition && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME") ? 
                                                    <>
                                                        <div className="col-3">
                                                            {(competition && competition.imgUrl) ? (
                                                                <>
                                                                    <label>Chủ đề</label>
                                                                    <img src={competition.imgUrl} />
                                                                </>
                                                            ) : ""}
                                                        </div>
                                                        <div className="col-3">
                                                            {(competition && competition.backgroundDialogUrl) ? (
                                                                <>
                                                                    <label>Ảnh Dialog</label>
                                                                    <img src={competition.backgroundDialogUrl} />
                                                                </>
                                                            ) : ""}
                                                        </div>
                                                    </>
                                                    : <>
                                                        <div className="col-3">
                                                        </div>
                                                        <div className="col-3">
                                                        </div>
                                                    </>
                                                }
                                               
                                            </div>
                                            {competition && competition.idEvent == "RoomEvent" && (
                                                <>
                                                    <div id="largeBackgroundUrl" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Banner lớn sự kiện</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                type="file"
                                                                className="custom-file-input"
                                                                name="largeBackgroundUrl"
                                                                onChange={this.uploadAnimationToS3}
                                                            />
                                                            <label className="custom-file-label ml-3 mr-3" htmlFor="largeBackgroundUrl">Choose file</label>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label></label>
                                                        </div>
                                                        <div className="col-3">
                                                            {(competition && competition.largeBackgroundUrl) ? (
                                                                <>
                                                                    <label>Banner Lớn</label>
                                                                    <img src={competition.largeBackgroundUrl} />
                                                                </>
                                                            ) : ""}
                                                        </div>
                                                    </div>

                                                </>
                                                
                                            )}


                                            {competition && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME") ? 
                                                <>
                                                    <div className="row mb-2">
                                                        <div className="col-5">
                                                        </div>
                                                        <div className="col-7">
                                                            <label>Mã màu</label>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Cuộc thi</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeContest"
                                                                placeholder="Mã màu cuộc thi"
                                                                {...model('competition.backgroundCode.backgroundCodeContest')}
                                                            />
                                                        </div>
                                                       <div className="col-5">
                                                            {
                                                                (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeContest) ? (                                                                
                                                                    isHexColor6(competition.backgroundCode.backgroundCodeContest) ? (
                                                                        <div style={{ 
                                                                            marginTop: '1%', 
                                                                            marginRight: '1%', 
                                                                            marginLeft: '1%', 
                                                                            marginBottom: '1%', 
                                                                            height: '75%', 
                                                                            width: '100%', 
                                                                            backgroundColor: competition.backgroundCode.backgroundCodeContest 
                                                                        }} />
                                                                    ) : (
                                                                        /* Trường hợp mã màu SAI: Hiển thị thông báo lỗi màu đỏ */
                                                                        <div className="text-danger">
                                                                            <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                Mã màu sai định dạng (VD: #FFFFFF)
                                                                            </h5>
                                                                        </div>
                                                                    )
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Tên cuộc thi</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeContestName"
                                                                placeholder="Mã màu tên cuộc thi"
                                                                {...model('competition.backgroundCode.backgroundCodeContestName')}
                                                            />
                                                        </div>
                                                       <div className="col-5">
                                                            {
                                                                (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeContestName) ? (
                                                                    isHexColor6(competition.backgroundCode.backgroundCodeContestName) ? (
                                                                        <div style={{ 
                                                                            marginTop: '1%', 
                                                                            marginRight: '1%', 
                                                                            marginLeft: '1%', 
                                                                            marginBottom: '1%', 
                                                                            height: '75%', 
                                                                            width: '100%', 
                                                                            backgroundColor: competition.backgroundCode.backgroundCodeContestName 
                                                                        }} />
                                                                    ) : (
                                                                        <div className="text-danger">
                                                                            <h5 style={{ color: 'red' }}>Mã màu sai định dạng (VD: #FFFFFF)</h5>
                                                                        </div>
                                                                    )
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Thể lệ</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeRule"
                                                                placeholder="Mã màu thể lệ"
                                                                {...model('competition.backgroundCode.backgroundCodeRule')}
                                                            />
                                                        </div>
                                                        <div className="col-5">
                                                            {
                                                                (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeRule) ? (
                                                                    isHexColor6(competition.backgroundCode.backgroundCodeRule) ? (
                                                                        <div style={{ 
                                                                            marginTop: '1%', 
                                                                            marginRight: '1%', 
                                                                            marginLeft: '1%', 
                                                                            marginBottom: '1%', 
                                                                            height: '75%', 
                                                                            width: '100%', 
                                                                            backgroundColor: competition.backgroundCode.backgroundCodeRule 
                                                                        }} />
                                                                    ) : (
                                                                        <div className="text-danger">
                                                                            <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                Mã màu sai định dạng (VD: #FFFFFF)
                                                                            </h5>
                                                                        </div>
                                                                    )
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Vòng 1</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeRound1"
                                                                placeholder="Mã màu vòng 1"
                                                                {...model('competition.backgroundCode.backgroundCodeRound1')}
                                                            />
                                                        </div>
                                                        <div className="col-5">
                                                            {
                                                                (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeRound1) ? (
                                                                    isHexColor6(competition.backgroundCode.backgroundCodeRound1) ? (
                                                                        <div style={{ 
                                                                            marginTop: '1%', 
                                                                            marginRight: '1%', 
                                                                            marginLeft: '1%', 
                                                                            marginBottom: '1%', 
                                                                            height: '75%', 
                                                                            width: '100%', 
                                                                            backgroundColor: competition.backgroundCode.backgroundCodeRound1 
                                                                        }} />
                                                                    ) : (
                                                                        <div className="text-danger">
                                                                            <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                Mã màu sai định dạng (VD: #FFFFFF)
                                                                            </h5>
                                                                        </div>
                                                                    )
                                                                ) : ""
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu BXH</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeRank"
                                                                placeholder="Mã màu BXH"
                                                                {...model('competition.backgroundCode.backgroundCodeRank')}
                                                            />
                                                        </div>
                                                       <div className="col-5">
                                                            {
                                                                (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeRank) ? (
                                                                isHexColor6(competition.backgroundCode.backgroundCodeRank) ? (
                                                                    <div
                                                                    style={{
                                                                        marginTop: '1%',
                                                                        marginRight: '1%',
                                                                        marginLeft: '1%',
                                                                        marginBottom: '1%',
                                                                        height: '75%',
                                                                        width: '100%',
                                                                        backgroundColor: competition.backgroundCode.backgroundCodeRank
                                                                    }}
                                                                    />
                                                                ) : (
                                                                    <div className="text-danger">
                                                                    <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                        Mã màu sai định dạng (VD: #FFFFFF)
                                                                    </h5>
                                                                    </div>
                                                                )
                                                                ) : ""
                                                            }
                                                            </div>

                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Button</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeButton"
                                                                placeholder="Mã màu button"
                                                                {...model('competition.backgroundCode.backgroundCodeButton')}
                                                            />
                                                        </div>
                                                       <div className="col-5">
                                                        {
                                                            (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeButton) ? (
                                                            isHexColor6(competition.backgroundCode.backgroundCodeButton) ? (
                                                                <div
                                                                style={{
                                                                    marginTop: '1%',
                                                                    marginRight: '1%',
                                                                    marginLeft: '1%',
                                                                    marginBottom: '1%',
                                                                    height: '75%',
                                                                    width: '100%',
                                                                    backgroundColor: competition.backgroundCode.backgroundCodeButton
                                                                }}
                                                                />
                                                            ) : (
                                                                <div className="text-danger">
                                                                <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                    Mã màu sai định dạng (VD: #FFFFFF)
                                                                </h5>
                                                                </div>
                                                            )
                                                            ) : ""
                                                        }
                                                        </div>

                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Màu Footer</label>
                                                        </div>
                                                        <div className="form-check col-4">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="backgroundCodeFooter"
                                                                placeholder="Mã màu footer"
                                                                {...model('competition.backgroundCode.backgroundCodeFooter')}
                                                            />
                                                        </div>
                                                       <div className="col-5">
                                                        {
                                                            (competition && competition.backgroundCode && competition.backgroundCode.backgroundCodeFooter) ? (
                                                            isHexColor6(competition.backgroundCode.backgroundCodeFooter) ? (
                                                                <div
                                                                style={{
                                                                    marginTop: '1%',
                                                                    marginRight: '1%',
                                                                    marginLeft: '1%',
                                                                    marginBottom: '1%',
                                                                    height: '75%',
                                                                    width: '100%',
                                                                    backgroundColor: competition.backgroundCode.backgroundCodeFooter
                                                                }}
                                                                />
                                                            ) : (
                                                                <div className="text-danger">
                                                                <h5 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                    Mã màu sai định dạng (VD: #FFFFFF)
                                                                </h5>
                                                                </div>
                                                            )
                                                            ) : ""
                                                        }
                                                        </div>
                                                    </div>
                                                    <div id="describe" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Mô tả Cuộc thi</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="describe"
                                                                placeholder="Nhập mô tả..."
                                                                {...model('competition.describe')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="slogan" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Slogan</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="slogan"
                                                                placeholder="Nhập Slogan..."
                                                                {...model('competition.slogan')}
                                                            />
                                                        </div>
                                                    </div>
                                                    { competition && competition.idEvent == "TheVoice" &&
                                                        <div id="categoryId" className="row mb-2">
                                                            <div className="col-3">
                                                                <label>Chủ đề bài hát</label>
                                                            </div>
                                                            <div className="col-9">
                                                                <select
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="categoryId"
                                                                    {...model('competition.categoryId')}
                                                                >
                                                                    <option value=''>Chọn chủ đề</option>
                                                                    <option value='0' >SONG CA</option>
                                                                    <option value='1' >Song ca cùng Thần Tượng</option>
                                                                    {
                                                                        visibleCategories.map((category) => (
                                                                            <option key={category.id} value={category.id} >{category.name}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div id="titleTime" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Thời gian diễn ra</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="titleTime"
                                                                placeholder="Nhập thời gian..."
                                                                {...model('competition.theVoiceRuleFull.titleTime')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="detailTime" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Mô tả Thời gian diễn ra</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <textarea
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="detailTime"
                                                                placeholder="Nhập mô tả..."
                                                                {...model('competition.theVoiceRuleFull.detailTime')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="titleRule" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Tiêu đề luật cuộc thi</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="titleRule"
                                                                placeholder="Nhập tiêu đề..."
                                                                {...model('competition.theVoiceRuleFull.titleRule')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="detailRule" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Mô tả luật cuộc thi</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <textarea
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="titleRule"
                                                                placeholder="Nhập mô tả..."
                                                                {...model('competition.theVoiceRuleFull.detailRule')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="titleOther" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Tiêu đề khác</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="titleOther"
                                                                placeholder="Nhập tiêu đề..."
                                                                {...model('competition.theVoiceRuleFull.titleOther')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="detailOther" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Mô tả khác</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <textarea
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="detailOther"
                                                                placeholder="Nhập mô tả..."
                                                                {...model('competition.theVoiceRuleFull.detailOther')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div id="numRewardRound2 " className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Số lượng user trao giải</label>
                                                        </div>
                                                        <div className="col-9">
                                                            <input
                                                                className="form-control mb-2"
                                                                type="number"
                                                                name="numRewardRound2 "
                                                                placeholder="Nhập số lượng ..."
                                                                {...model('competition.numRewardRound2')}
                                                            />
                                                        </div>
                                                    </div>

                                                    { competition && competition.idEvent == "TheVoice" && 
                                                    <div>
                                                        <div id="typePermissionAccept" className="row mb-2">
                                                            <div className="col-3">
                                                                <label>Bài hát hợp lệ</label>
                                                            </div>
                                                            <div className="form-check col-9">
                                                                <select id='giftTop1Round1'
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="typePermissionAccept"
                                                                    {...model('competition.typePermissionAccept')} >
                                                                    <option value="">Chọn</option>
                                                                    <option value="PUBLIC">Công khai</option>
                                                                    <option value="PRIVATE">Riêng tư</option>
                                                                    <option value="ALL">Tất cả</option>
                                                                </select>
                                                                
                                                            </div>
                                                        </div>

                                                        <div id="typeRecordingAccept" className="row mb-2">
                                                            <div className="col-3">
                                                                <label>Hình thức hợp lệ</label>
                                                            </div>
                                                            <div className="form-check col-9">
                                                                <select id='giftTop1Round1'
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="typeRecordingAccept"
                                                                    {...model('competition.typeRecordingAccept')} >
                                                                    <option value="">Chọn</option>
                                                                    <option value="SOLO">Solo</option>
                                                                    <option value="DUET">Duet</option>
                                                                    <option value="ASK4DUET">Ask For Duet</option>
                                                                    <option value="ALL">All</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div id="typeRecordingMedia" className="row mb-2">
                                                            <div className="col-3">
                                                                <label>Bài dự thi</label>
                                                            </div>
                                                            <div className="form-check col-9">
                                                                <select id='typeRecordingAcceptSelected'
                                                                    className="form-control"
                                                                    name="typeRecordingMedia"
                                                                    {...model('competition.typeRecordingMedia')} >
                                                                    <option value="">Chọn</option>
                                                                    <option value="VIDEO">Hình</option>
                                                                    <option value="AUDIO">Tiếng</option>
                                                                    <option value="ALL">Cả 2</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    }

                                                    <div id="typeRecordingMedia" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Sticker DeepAr</label>
                                                        </div>
                                                        <div className="form-check col-9" id='choiceStickerDeepAr'>

                                                        </div>
                                                    </div>
                                                    <div id="deepAr" className="row mb-2">
                                                        <div className="col-3">
                                                            {/* <label>Sticker DeepAr</label> */}
                                                        </div>
                                                        <div className="form-check col-9">
                                                            <button className='btn btn-success'
                                                                onClick={this.handleShowChoice}>Thêm</button>
                                                        </div>
                                                    </div>
                                                    <div id="typeRecordingMedia" className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Hashtag</label>
                                                        </div>
                                                        <div className="form-check col-9" id='choiceHashtag'>
                                                        </div>
                                                    </div>
                                                    <div id="deepAr" className="row mb-2">
                                                        <div className="col-3">
                                                            {/* <label>Sticker DeepAr</label> */}
                                                        </div>
                                                        <div className="form-check col-9">
                                                            <button className='btn btn-success'
                                                                onClick={this.handleShowHashtag}>Thêm</button>
                                                        </div>
                                                    </div>
                                                </>
                                                : competition && competition.idEvent == "WebView" ? <>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Deep link App</label>
                                                        </div>
                                                        <div className="form-check col-9">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="deepLink"
                                                                placeholder="Deep link"
                                                                {...model('competition.deepLink')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Web Chuẩn bị</label>
                                                        </div>
                                                        <div className="form-check col-9">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="inProgressLink"
                                                                placeholder="In progress link"
                                                                {...model('competition.inProgressLink')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2">
                                                        <div className="col-3">
                                                            <label>Web Hoàn thành</label>
                                                        </div>
                                                        <div className="form-check col-9">
                                                            <input
                                                                height={40}
                                                                className="form-control mb-2"
                                                                type="text"
                                                                name="doneLink"
                                                                placeholder="Done link"
                                                                {...model('competition.doneLink')}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                                : competition && (competition.idEvent == "Custom") ?
                                                <>
                                                <div id="imgUrl" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Ảnh nền</label>
                                                    </div>
                                                    <div className="col-9">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            name="imgUrl"
                                                            onChange={this.uploadAnimationToS4} />
                                                        <label className="custom-file-label ml-3 mr-3" htmlFor="imgUrl">Choose file</label>
                                                    </div>
                                                </div>
                                                <div id="ruleImgUrl" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Ảnh thể lệ</label>
                                                    </div>
                                                    <div className="col-9">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            name="ruleImgUrl"
                                                            onChange={this.uploadAnimationToS4} />
                                                        <label className="custom-file-label ml-3 mr-3" htmlFor="ruleImgUrl">Choose file</label>
                                                    </div>
                                                </div>
                                                <div id="markIcon" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Icon điểm</label>
                                                    </div>
                                                    <div className="col-9">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            name="markIcon"
                                                            onChange={this.uploadAnimationToS4} />
                                                        <label className="custom-file-label ml-3 mr-3" htmlFor="markIcon">Choose file</label>
                                                    </div>
                                                </div>
                                                {/* Preview ảnh */}
                                                <div className="row mb-2">
                                                    <div className="col-3">
                                                        <label></label>
                                                    </div>
                                                    <div className="col-3">
                                                        {(competition && competition.imgUrl) ? (
                                                            <>
                                                                <label>Ảnh nền</label>
                                                                <img src={competition.imgUrl} style={{ width: '100%', maxWidth: '200px' }} alt="Background" />
                                                            </>
                                                        ) : ""}
                                                    </div>
                                                    <div className="col-3">
                                                        {(competition && competition.ruleImgUrl) ? (
                                                            <>
                                                                <label>Ảnh thể lệ</label>
                                                                <img src={competition.ruleImgUrl} style={{ width: '100%', maxWidth: '200px' }} alt="Rule" />
                                                            </>
                                                        ) : ""}
                                                    </div>
                                                    <div className="col-3">
                                                        {(competition && competition.markIcon) ? (
                                                            <>
                                                                <label>Icon điểm</label>
                                                                <img src={competition.markIcon} style={{ width: '100%', maxWidth: '100px' }} alt="Mark Icon" />
                                                            </>
                                                        ) : ""}
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Màu nền</label>
                                                    </div>
                                                    <div className="form-check col-3">
                                                        <input
                                                            height={40}
                                                            className="form-control mb-2"
                                                            type="text"
                                                            name="backgroundCodeContest"
                                                            placeholder="Mã màu (#FFFFFF)"
                                                            {...model('competition.backgroundCode.backgroundCodeContest')}
                                                        />
                                                    </div>
                                                    <div className="col-4">
                                                    {
                                                        (competition &&
                                                        competition.backgroundCode &&
                                                        competition.backgroundCode.backgroundCodeContest) ? (
                                                            isHexColor6(competition.backgroundCode.backgroundCodeContest) ? (
                                                            <div
                                                                style={{
                                                                marginTop: '1%',
                                                                marginRight: '1%',
                                                                marginLeft: '1%',
                                                                marginBottom: '1%',
                                                                height: '75%',
                                                                width: '100%',
                                                                backgroundColor: competition.backgroundCode.backgroundCodeContest
                                                                }}
                                                            />
                                                            ) : (
                                                            <div className="text-danger">
                                                                <h6 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                Mã màu sai định dạng (VD: #FFFFFF)
                                                                </h6>
                                                            </div>
                                                            )
                                                        ) : ""
                                                    }
                                                    </div>

                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Màu footer</label>
                                                    </div>
                                                    <div className="form-check col-3">
                                                        <input
                                                            height={40}
                                                            className="form-control mb-2"
                                                            type="text"
                                                            name="backgroundCodeFooter"
                                                            placeholder="Mã màu (#FFFFFF)"
                                                            {...model('competition.backgroundCode.backgroundCodeFooter')}
                                                        />
                                                    </div>
                                                    <div className="col-4">
                                                    {
                                                        (competition &&
                                                        competition.backgroundCode &&
                                                        competition.backgroundCode.backgroundCodeFooter) ? (
                                                            isHexColor6(competition.backgroundCode.backgroundCodeFooter) ? (
                                                            <div
                                                                style={{
                                                                marginTop: '1%',
                                                                marginRight: '1%',
                                                                marginLeft: '1%',
                                                                marginBottom: '1%',
                                                                height: '75%',
                                                                width: '100%',
                                                                backgroundColor: competition.backgroundCode.backgroundCodeFooter
                                                                }}
                                                            />
                                                            ) : (
                                                            <div className="text-danger">
                                                                <h6 style={{ color: 'red', fontWeight: 'bold' }}>
                                                                Mã màu sai định dạng (VD: #FFFFFF)
                                                                </h6>
                                                            </div>
                                                            )
                                                        ) : ""
                                                    }
                                                    </div>

                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Deep link nút Tham gia</label>
                                                    </div>
                                                    <div className="form-check col-9">
                                                        <input
                                                            height={40}
                                                            className="form-control mb-2"
                                                            type="text"
                                                            name="deepLinkJoinButton"
                                                            placeholder="Deep link"
                                                            {...model('competition.deepLinkJoinButton')}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="leaderboardKind" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Loại BXH</label>
                                                    </div>
                                                    <div className="form-check col-9">
                                                        <select
                                                            className="form-control"
                                                            type="text"
                                                            name="leaderboardKind"
                                                            {...model('competition.leaderboardKind')} 
                                                            >
                                                            <option value="">Chọn loại BXH</option>
                                                            {this.state.leaderboardKinds.map((kind, index) => (
                                                                <option key={index} value={kind.id}>{kind.value}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {this.state.competition && this.state.competition.leaderboardKind === 'FIRE_STREAK' && (
                                                    <div id="streakConfig" className="border rounded p-3 mb-3" style={{ background: '#fff7f5' }}>
                                                        <h5 className="mb-2" style={{ color: '#e53935' }}>Cấu hình Sự kiện Giữ Chuỗi</h5>
                                                        {!(this.state.competition && this.state.competition._id) && (
                                                            <div className="alert alert-warning py-2">
                                                                Lưu cuộc thi trước (để có ID), rồi mở lại để cấu hình Giữ Chuỗi.
                                                            </div>
                                                        )}
                                                        <div className="row mb-2">
                                                            <div className="col-3"><label>Live Room ID (phòng đăng bài)</label></div>
                                                            <div className="col-3">
                                                                <input className="form-control" value={this.state.streak.liveRoomId}
                                                                    onChange={(e) => this.updateStreakField('liveRoomId', e.target.value)} />
                                                            </div>
                                                            <div className="col-3"><label>Poster UID (ADMIN phòng)</label></div>
                                                            <div className="col-3">
                                                                <input className="form-control" value={this.state.streak.posterUid}
                                                                    onChange={(e) => this.updateStreakField('posterUid', e.target.value)} />
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col-3"><label>Số ngày/chặng (mặc định 3)</label></div>
                                                            <div className="col-3">
                                                                <input className="form-control" value={this.state.streak.milestoneLen}
                                                                    onChange={(e) => this.updateStreakField('milestoneLen', e.target.value)} />
                                                            </div>
                                                            <div className="col-6">
                                                                <small className="text-muted">Bài đăng tự động lúc 00:00; điểm danh tính trọn ngày (0h–23h59).</small>
                                                            </div>
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col-3"><label>Gift ID (quà, mặc định HOA CA)</label></div>
                                                            <div className="col-9">
                                                                <input className="form-control" value={this.state.streak.giftId}
                                                                    onChange={(e) => this.updateStreakField('giftId', e.target.value)} />
                                                            </div>
                                                        </div>

                                                        <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                                            <label className="mb-0"><b>Bài đăng theo ngày</b></label>
                                                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={this.generateStreakDays}>
                                                                ↻ Tạo bài theo số ngày sự kiện
                                                            </button>
                                                            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={this.addStreakRow}>
                                                                + Thêm ngày
                                                            </button>
                                                        </div>
                                                        <small className="text-muted d-block mb-2">
                                                            Bấm "Tạo bài theo số ngày sự kiện" để tự sinh mỗi ngày (từ Thời gian bắt đầu → kết thúc) một dòng, rồi nhập caption/ảnh.
                                                        </small>

                                                        {this.state.streak.dailyPosts.length > 0 && (
                                                            <table className="table table-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ width: '130px' }}>Ngày (yyyyMMdd)</th>
                                                                        <th>Caption</th>
                                                                        <th>Image URL</th>
                                                                        <th style={{ width: '140px' }}>Trạng thái</th>
                                                                        <th style={{ width: '40px' }}></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.state.streak.dailyPosts.map((r, idx) => (
                                                                        <tr key={idx}>
                                                                            <td>
                                                                                <input className="form-control form-control-sm" value={r.eventDate || ''}
                                                                                    onChange={(e) => this.updateStreakRow(idx, 'eventDate', e.target.value)} />
                                                                            </td>
                                                                            <td>
                                                                                <textarea className="form-control form-control-sm" rows={3}
                                                                                    style={{ whiteSpace: 'pre-wrap', resize: 'vertical' }}
                                                                                    value={r.caption || ''}
                                                                                    onChange={(e) => this.updateStreakRow(idx, 'caption', e.target.value)} />
                                                                            </td>
                                                                            <td>
                                                                                <input className="form-control form-control-sm mb-1" placeholder="URL ảnh (hoặc upload ↓)"
                                                                                    value={r.imageUrl || ''}
                                                                                    onChange={(e) => this.updateStreakRow(idx, 'imageUrl', e.target.value)} />
                                                                                <input type="file" accept="image/*" className="form-control form-control-sm"
                                                                                    onChange={(e) => this.uploadStreakImage(idx, e)} />
                                                                                {r.imageUrl ? (
                                                                                    <img src={r.imageUrl} alt="preview"
                                                                                        style={{ maxWidth: '90px', maxHeight: '70px', marginTop: '4px', objectFit: 'cover', display: 'block' }} />
                                                                                ) : null}
                                                                            </td>
                                                                            <td>
                                                                                <div style={{ fontSize: '12px', marginBottom: '4px' }}>
                                                                                    {r.postStatus === 'POSTED'
                                                                                        ? <span style={{ color: '#1a7f37' }}>✓ Đã đăng</span>
                                                                                        : r.postStatus === 'FAILED'
                                                                                            ? <span style={{ color: '#d1242f' }}>✕ Lỗi đăng</span>
                                                                                            : r.postStatus === 'POSTING'
                                                                                                ? <span style={{ color: '#9a6700' }}>… Đang đăng</span>
                                                                                                : <span style={{ color: '#6e7781' }}>{r.postStatus || 'Chưa lưu'}</span>}
                                                                                </div>
                                                                                {(r.postStatus && r.postStatus !== 'POSTED') ? (
                                                                                    <button type="button" className="btn btn-outline-primary btn-sm"
                                                                                        onClick={() => this.retryStreakPost(idx)}>Đăng lại</button>
                                                                                ) : null}
                                                                            </td>
                                                                            <td>
                                                                                <button type="button" className="btn btn-outline-danger btn-sm"
                                                                                    onClick={() => this.removeStreakRow(idx)}>✕</button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        )}

                                                        <button type="button" className="btn btn-red"
                                                            disabled={this.state.streak.saving}
                                                            onClick={this.saveStreakConfig}>
                                                            {this.state.streak.saving ? 'Đang lưu...' : 'Lưu cấu hình Giữ Chuỗi'}
                                                        </button>
                                                    </div>
                                                )}

                                                {this.state.competition && this.state.competition.leaderboardKind === 'RECORDING_CONTEST' && (
                                                    <div id="recordingContestConfig" className="border rounded p-3 mb-3" style={{ background: '#f2f8ff' }}>
                                                        <h5 className="mb-2" style={{ color: '#1565c0' }}>Cấu hình BXH Bài Thu</h5>
                                                        {!(this.state.competition && this.state.competition._id) && (
                                                            <div className="alert alert-warning py-2">
                                                                Lưu cuộc thi trước (để có ID), rồi mở lại để cấu hình BXH Bài Thu.
                                                            </div>
                                                        )}

                                                        <div className="row mb-2">
                                                            <div className="col-3"><label>Giới hạn Level tham gia</label></div>
                                                            <div className="col-9">
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox"
                                                                        id="recordingContestLevelCheck"
                                                                        checked={this.state.recordingContest.levelCheckEnabled}
                                                                        onChange={(e) => this.updateRecordingContestField('levelCheckEnabled', e.target.checked)} />
                                                                    <label className="form-check-label" htmlFor="recordingContestLevelCheck">
                                                                        Chỉ cho phép người dùng trong khoảng Level dưới đây gửi bài dự thi
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.recordingContest.levelCheckEnabled && (
                                                            <div className="row mb-2">
                                                                <div className="col-3"><label>Từ Level</label></div>
                                                                <div className="col-3">
                                                                    <input className="form-control" type="number" min="1"
                                                                        value={this.state.recordingContest.minLevel}
                                                                        onChange={(e) => this.updateRecordingContestField('minLevel', e.target.value)} />
                                                                </div>
                                                                <div className="col-3"><label>Đến Level</label></div>
                                                                <div className="col-3">
                                                                    <input className="form-control" type="number" min="1"
                                                                        value={this.state.recordingContest.maxLevel}
                                                                        onChange={(e) => this.updateRecordingContestField('maxLevel', e.target.value)} />
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="row mb-2">
                                                            <div className="col-3"><label>Số bài hiển thị trên BXH</label></div>
                                                            <div className="col-3">
                                                                <input className="form-control" type="number" min="1" max="50"
                                                                    value={this.state.recordingContest.topSize}
                                                                    onChange={(e) => this.updateRecordingContestField('topSize', e.target.value)} />
                                                            </div>
                                                            <div className="col-6">
                                                                <small className="text-muted">
                                                                    Điểm bài thu = lượt thích + lượt bình luận hợp lệ + lượt nghe hợp lệ, tính trong thời gian sự kiện. Sắp xếp từ cao xuống thấp.
                                                                </small>
                                                            </div>
                                                        </div>

                                                        <button type="button" className="btn btn-red"
                                                            disabled={this.state.recordingContest.saving}
                                                            onClick={this.saveRecordingContestConfig}>
                                                            {this.state.recordingContest.saving ? 'Đang lưu...' : 'Lưu cấu hình BXH Bài Thu'}
                                                        </button>
                                                    </div>
                                                )}
                                                </>
                                                : <></>
                                            }
                                        
                                           
                                            <div id="name" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Tên Cuộc thi</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="text"
                                                        name="name"
                                                        placeholder="Nhập Tên cuộc thi..."
                                                        {...model('competition.name')}
                                                    />
                                                </div>
                                            </div>
                                            { competition && competition.idEvent == "RoomEvent" &&(
                                                <div id="timeStart" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Thời gian bắt đầu</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeStart"
                                                        {...model('competition.timeStart')}
                                                    />
                                                </div>
                                            </div>
                                            
                                            )}
                                            { competition && competition.idEvent == "RoomEvent" &&(
                                                <div id="timeEnd" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Thời gian kết thúc</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeEnd"
                                                        {...model('competition.timeEnd')}
                                                    />
                                                </div>
                                            </div>
                                            
                                            )}
                                            <div id="timeShowStart" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Hẹn giờ đăng</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeShowStart"
                                                        {...model('competition.timeShowStart')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="timeShowEnd" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Hẹn giờ Kết thúc</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeShowEnd"
                                                        {...model('competition.timeShowEnd')}
                                                    />
                                                </div>
                                            </div>
                                            { competition && competition.idEvent == "RoomEvent" &&(
                                                <div id="isHidden" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Ẩn sự kiện</label>
                                                    </div>
                                                    <div className="col-2">
                                                        <input 
                                                            type="checkbox" 
                                                            className="form-control" 
                                                            style={{
                                                                width: "15px",
                                                                outline: "none",
                                                                boxShadow: "none"
                                                            }}
                                                            name="isHidden" 
                                                            {...model('competition.isHidden')} 
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            { competition && competition.idEvent == "RoomEvent" &&(
                                                <div id="isSendNotification" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Gửi thông báo</label>
                                                    </div>
                                                    <div className="col-3">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="checkbox" 
                                                            name="isSendNotification"
                                                            {...model('competition.isSendNotification')}
                                                            style={{
                                                                width: "15px",
                                                                outline: "none",
                                                                boxShadow: "none"
                                                            }}
                                                            checked={competition.isSendNotification}
                                                            onChange={this.handleChangeIsSendNotification}
                                                        />
                                                    </div>
                                                </div>)}
                                            { competition && competition.idEvent == "RoomEvent" &&(
                                                <div id="timeSendNotification" className="row mb-2" hidden={!competition.isSendNotification}>
                                                    <div className="col-3">
                                                        <label>Thời gian gửi thông báo</label>
                                                    </div>
                                                    <div className="col-9">
                                                    <input
                                                            className="form-control mb-2"
                                                            type="datetime-local"
                                                            name="timeSendNotification"
                                                            {...model('competition.timeSendNotification')}
                                                        />
                                                    </div>
                                                </div>)}
                                        </div>
                                    </div>

                                    {/* Vòng thi */}
                                    <div className="tab-pane fade" id="rounds" role="tabpanel" aria-labelledby="rounds-tab">
                                        <br /><br />

                                        <div id="round1" className='border border-primary'>
                                            <h4>Vòng 1</h4>
                                            <div id="timeStartRound1" className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-3">
                                                    <label>Thời gian bắt đầu</label>
                                                </div>
                                                <div className="col-7">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeStartRound1"
                                                        {...model('competition.timeStartRound1')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="timeEndRound1" className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-3">
                                                    <label>Thời gian kết thúc</label>
                                                </div>
                                                <div className="col-7">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeEndRound1"
                                                        {...model('competition.timeEndRound1')}
                                                    />
                                                </div>
                                            </div>
                                            
                                            { competition && competition.idEvent == "TheVoice" &&
                                                <>
                                                <div id="limitRecordingRound1" className="row mb-2">
                                                    <div className="col-1">
                                                    </div>
                                                    <div className="col-3">
                                                        <label>Tổng bài dự thi tối đa</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="number"
                                                            name="limitRecordingRound1"
                                                            placeholder="Nhập Số bài..."
                                                            {...model('competition.limitRecordingRound1')}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="maxNumMediaOneUse" className="row mb-2">
                                                    <div className="col-1">
                                                    </div>
                                                    <div className="col-3">
                                                        <label>Số bài dự thi của 1 user</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="number"
                                                            name="maxNumMediaOneUse"
                                                            placeholder="Nhập Số bài..."
                                                            {...model('competition.maxNumMediaOneUse')}
                                                        />
                                                    </div>
                                                </div>
                                                <div id="limitRecordingRound2" className="row mb-2">
                                                    <div className="col-1">
                                                    </div>
                                                    <div className="col-3">
                                                        <label>Số bài đc lấy vào vòng 2</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="number"
                                                            name="limitRecordingRound2"
                                                            placeholder="Nhập Số bài..."
                                                            {...model('competition.limitRecordingRound2')}
                                                        />
                                                    </div>
                                                </div>
                                                <br />
                                            
                                            </>}
                                            

                                        </div>

                                        <br /><br />
                                        { competition && competition.idEvent == "TheVoice" &&
                                            <div id="round2" className='border border-primary'>
                                                <h4>Vòng 2</h4>
                                                <div id="timeEndRound2" className="row mb-2">
                                                    <div className="col-1">
                                                    </div>
                                                    <div className="col-3">
                                                        <label>Thời gian kết thúc</label>
                                                    </div>
                                                    <div className="col-7">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="datetime-local"
                                                            name="timeEndRound2"
                                                            {...model('competition.timeEndRound2')}
                                                        />
                                                    </div>
                                                </div>
                                                    <div>
                                                        <div id="minNumMark" className="row mb-2">
                                                            <div className="col-1">
                                                            </div>
                                                            <div className="col-3">
                                                                <label>Số giám khảo tối thiểu </label>
                                                            </div>
                                                            <div className="col-7">
                                                                <input
                                                                    className="form-control mb-2"
                                                                    type="number"
                                                                    name="minNumMark"
                                                                    placeholder="Nhập số giám khảo tối thiểu..."
                                                                    {...model('competition.minNumMark')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div id="minLevelExaminer" className="row mb-2">
                                                            <div className="col-1">
                                                            </div>
                                                            <div className="col-3">
                                                                <label>Level của giám khảo đc vào chấm</label>
                                                            </div>
                                                            <div className="col-7">
                                                                <input
                                                                    className="form-control mb-2"
                                                                    type="number"
                                                                    name="minLevelExaminer"
                                                                    placeholder="Nhập Level giám khảo..."
                                                                    {...model('competition.minLevelExaminer')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div id="maxMediaForOneExaminer" className="row mb-2">
                                                            <div className="col-1">
                                                            </div>
                                                            <div className="col-3">
                                                                <label>Mỗi giám khảo đc chấm bao nhiêu bài</label>
                                                            </div>
                                                            <div className="col-7">
                                                                <input
                                                                    className="form-control mb-2"
                                                                    type="number"
                                                                    name="maxMediaForOneExaminer"
                                                                    placeholder="Nhập số bài được chấm..."
                                                                    {...model('competition.maxMediaForOneExaminer')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div id="maxExaminerForOneMedia" className="row mb-2">
                                                            <div className="col-1">
                                                            </div>
                                                            <div className="col-3">
                                                                <label>Mỗi bài đc bao nhiêu giám khảo vào chấm </label>
                                                            </div>
                                                            <div className="col-7">
                                                                <input
                                                                    className="form-control mb-2"
                                                                    type="number"
                                                                    name="maxExaminerForOneMedia"
                                                                    placeholder="Nhập Số giám khảo..."
                                                                    {...model('competition.maxExaminerForOneMedia')}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div id="canApplyExaminer" className="row mb-2">
                                                            <div className="col-1">
                                                            </div>
                                                            <div className="col-3">
                                                                <label>Cho phép tự ứng cử làm giám khảo</label>
                                                            </div>
                                                            <div className="col-7">
                                                                <select
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="canApplyExaminer"
                                                                    {...model('competition.canApplyExaminer')}
                                                                >
                                                                    <option value='' >Chọn</option>
                                                                    <option value='1' >CHO PHÉP</option>
                                                                    <option value='0' >KHÔNG</option>
                                                                </select>
                                                            </div>
                                                        </div> 
                                                    </div>
                                                <br />
                                            </div>
                                        }
                                    </div>

                                    {/* QUÀ */}
                                    <div className="tab-pane fade" id="gift" role="tabpanel" aria-labelledby="gift-tab">
                                        <br /><br />
                                        <div id="giftsTop1" className='border border-primary'>
                                            <h4>Quà Top 1</h4>

                                            {/* CUP, Quà, Khung Bài thu, Huy hiệu Bài thu */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>CUP</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà</label>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                            <label>Khung Bài thu</label>
                                                    </div> : <div className="col-2"></div>


                                                }

                                                <div className="col-2">
                                                    {competition && competition.idEvent == "TheVoice" ? (
                                                        <label>Huy hiệu Bài thu</label>
                                                    ) : competition && competition.idEvent == "GAME" ? (
                                                        <label>Huy hiệu Game</label>
                                                    ) : null}
                                                </div>

                                                <div className="col-2">
                                                    <label>Hiệu ứng khi hát</label>
                                                </div>

                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcupTop1' id="cupTop1"
                                                        placeholder='Chọn Cup'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcupTop1"
                                                    >
                                                        <option value="">Chọn Cup</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dgifTop1' id="gifTop1"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dgifTop1"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option name={value.url} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                            <input list='dfraTop1' id="fraTop1"
                                                                placeholder='Chọn Khung trang trí bài thu'
                                                                onChange={this.showImgPreview} />
                                                            <datalist
                                                                id="dfraTop1"
                                                            >
                                                                <option value="">Chọn khung Top 1</option>
                                                                {
                                                                    frameDecoration && frameDecoration.map((value) => (
                                                                        <option key={value.id} value={value.name} >
                                                                        </option>
                                                                    ))
                                                                }
                                                            </datalist>
                                                        </div> : <div className="col-2"></div>

                                                }
                                                {competition && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME") ? (
                                                    <div className="col-2">
                                                        <input list='dmedTop1' id="medTop1"
                                                            placeholder={competition.idEvent == "TheVoice" ? 'Chọn huy hiệu trang trí bài thu' : 'Chọn huy hiệu trang trí Game'}
                                                            onChange={this.showImgPreview} />
                                                        <datalist id="dmedTop1">
                                                            <option value="">Chọn huy hiệu</option>
                                                            {medalDecoration && medalDecoration.map((value) => (
                                                                <option key={value.id} value={value.name}></option>
                                                            ))}
                                                        </datalist>
                                                    </div>
                                                ) : (
                                                    <div className="col-2"></div>
                                                )}
                                                <div className="col-2">
                                                    <input list='dsinTop1' id="sinTop1"
                                                        placeholder='Chọn Hiệu ứng Hát'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dsinTop1"
                                                    >
                                                        <option value="">Chọn Hiệu ứng hát</option>
                                                        {
                                                            singEffects && singEffects.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                            </div>
                                            {/* XEM TRƯỚC ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].cup &&
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].cup.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].cup = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cupTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].gift &&
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].gift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].gift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("gifTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                    }
                                                </div>
                                                {
                                                    (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].recordingFrame && competition.idEvent == "TheVoice") ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[0].recordingFrame.thumbnailUrl}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[0].recordingFrame = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("fraTop1").value = "";
                                                            }}
                                                        >x</button>
                                                    </div> : <div className="col-2"></div>

                                                }
                               
                                                {
                                                    (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].recordingMedal && (competition.idEvent == "TheVoice" || competition.idEvent == "GAME")) ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[0].recordingMedal.thumbnailUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].recordingMedal = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("medTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                    </div> : <div className="col-2"></div>
                                                }
    
                                                <div className="col-2">
                                                    {
                                                        competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].singEffects &&
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].singEffects.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].singEffects = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("sinTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                    }
                                                </div>
                                            </div>
                                            <br />
                                            {/* Avatar, Khung bình luận, Thẻ cá nhân, Trang trí cá nhân, Hiệu ứng vào phòng */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Avatar</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Khung bình luận</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Thẻ cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Trang trí cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Hiệu ứng vào phòng</label>
                                                </div>
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='davaTop1' id="avaTop1"
                                                        placeholder='Chọn Khung'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="davaTop1"
                                                    >
                                                        <option value="">Chọn Khung</option>
                                                        {
                                                            avas && avas.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcmtTop1' id="cmtTop1"
                                                        placeholder='Chọn hiệu ứng bình luận'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcmtTop1"
                                                    >
                                                        <option value="">Chọn hiệu ứng bình luận</option>
                                                        {
                                                            commentFrames && commentFrames.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dprsTop1' id="prsTop1"
                                                        placeholder='Chọn thẻ cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dprsTop1"
                                                    >
                                                        <option value="">Chọn thẻ cá nhân</option>
                                                        {
                                                            personalCards && personalCards.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dudcTop1' id="udcTop1"
                                                        placeholder='Chọn trang trí cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dudcTop1"
                                                    >
                                                        <option value="">Chọn trang trí cá nhân</option>
                                                        {
                                                            userDecorations && userDecorations.map((value) => (
                                                                <option name={value.url} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='drooTop1' id="rooTop1"
                                                        placeholder='Chọn Hiệu ứng vào phòng'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drooTop1"
                                                    >
                                                        <option value="">Chọn Hiệu ứng vào phòng</option>
                                                        {
                                                            roomEntryEffects && roomEntryEffects.map((value) => (
                                                                <option key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].avatarFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].avatarFrame.previewImg}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].avatarFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("avaTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].commentFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].commentFrame.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].commentFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cmtTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].personalCard) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].personalCard.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].personalCard = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("prsTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].userDecoration) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].userDecoration.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].userDecoration = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("udcTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].roomEntryEffect) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].roomEntryEffect.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].roomEntryEffect = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rooTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />

                                            {/* Quà vật lý */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà vật lý</label>
                                                </div>

                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='drgfTop1' id="rgfTop1"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drgfTop1"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            realGifts && realGifts.map((value) => (
                                                                <option name={value.name} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>

                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[0].realGift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[0].realGift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[0].realGift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rgfTop1").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />
                                        </div>

                                        <br /><br />
                                        <div id="giftsTop2" className='border border-primary'>
                                            <h4>Quà Top 2</h4>

                                            {/* CUP, Quà, Khung Bài thu, Huy hiệu Bài thu */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>CUP</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà</label>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ? 
                                                    <div className="col-2">
                                                            <label>Khung Bài thu</label>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                {
                                                    competition && competition.idEvent == "TheVoice" ? 
                                                    <div className="col-2">
                                                            <label>Huy hiệu Bài thu</label>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                <div className="col-2">
                                                    <label>Hiệu ứng khi hát</label>
                                                </div>
                                              
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcupTop2' id="cupTop2"
                                                        placeholder='Chọn Cup'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcupTop2"
                                                    >
                                                        <option value="">Chọn Cup</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dgifTop2' id="gifTop2"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dgifTop2"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option name={value.url} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                            <input list='dfraTop2' id="fraTop2"
                                                                placeholder='Chọn Khung trang trí bài thu'
                                                                onChange={this.showImgPreview} />
                                                            <datalist
                                                                id="dfraTop2"
                                                            >
                                                                <option value="">Chọn khung</option>
                                                                {
                                                                    frameDecoration && frameDecoration.map((value) => (
                                                                        <option key={value.id} value={value.name} >
                                                                        </option>
                                                                    ))
                                                                }
                                                            </datalist>
                                                    </div> : <div className="col-2"></div>

                                                }
                                                { competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <input list='dmedTop2' id="medTop1"
                                                            placeholder='Chọn huy hiệu trang trí bài thu'
                                                            onChange={this.showImgPreview} />
                                                        <datalist
                                                            id="dmedTop2"
                                                        >
                                                            <option value="">Chọn huy hiệu</option>
                                                            {
                                                                medalDecoration && medalDecoration.map((value) => (
                                                                    <option key={value.id} value={value.name} >
                                                                    </option>
                                                                ))
                                                            }
                                                        </datalist>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                <div className="col-2">
                                                    <input list='dsinTop2' id="sinTop2"
                                                        placeholder='Chọn Hiệu ứng Hát'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dsinTop2"
                                                    >
                                                        <option value="">Chọn Hiệu ứng hát</option>
                                                        {
                                                            singEffects && singEffects.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                
                                            </div>
                                            {/* XEM TRƯỚC ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].cup) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].cup.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].cup = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cupTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].gift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].gift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].gift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("gifTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].recordingFrame && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[1].recordingFrame.thumbnailUrl}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[1].recordingFrame = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("fraTop2").value = "";
                                                            }}
                                                        >x</button>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].recordingMedal && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[1].recordingMedal.url}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[1].recordingMedal = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("medTop2").value = "";
                                                            }}
                                                        >x</button> 
                                                    </div> : <div className="col-2"></div>
                                                }
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].singEffects &&
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[1].singEffects.previewImg}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[1].singEffects = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("sinTop2").value = "";
                                                            }}
                                                        >x</button>
                                                    </div>
                                                }
                                            </div>
                                            <br />
                                            {/* Avatar, Khung bình luận, Thẻ cá nhân, Trang trí cá nhân, Hiệu ứng vào phòng */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Avatar</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Khung bình luận</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Thẻ cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Trang trí cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Hiệu ứng vào phòng</label>
                                                </div>
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='davaTop2' id="avaTop2"
                                                        placeholder='Chọn Khung'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="davaTop2"
                                                    >
                                                        <option value="">Chọn Khung</option>
                                                        {
                                                            avas && avas.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcmtTop2' id="cmtTop2"
                                                        placeholder='Chọn hiệu ứng bình luận'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcmtTop2"
                                                    >
                                                        <option value="">Chọn hiệu ứng bình luận</option>
                                                        {
                                                            commentFrames && commentFrames.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dprsTop2' id="prsTop2"
                                                        placeholder='Chọn thẻ cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dprsTop2"
                                                    >
                                                        <option value="">Chọn thẻ cá nhân</option>
                                                        {
                                                            personalCards && personalCards.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dudcTop2' id="udcTop2"
                                                        placeholder='Chọn trang trí cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dudcTop2"
                                                    >
                                                        <option value="">Chọn trang trí cá nhân</option>
                                                        {
                                                            userDecorations && userDecorations.map((value) => (
                                                                <option name={value.url} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='drooTop2' id="rooTop2"
                                                        placeholder='Chọn Hiệu ứng vào phòng'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drooTop2"
                                                    >
                                                        <option value="">Chọn Hiệu ứng vào phòng</option>
                                                        {
                                                            roomEntryEffects && roomEntryEffects.map((value) => (
                                                                <option key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].avatarFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].avatarFrame.previewImg}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].avatarFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("avaTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].commentFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].commentFrame.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].commentFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cmtTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].personalCard) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].personalCard.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].personalCard = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("prsTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].userDecoration) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].userDecoration.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].userDecoration = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("udcTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].roomEntryEffect) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].roomEntryEffect.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].roomEntryEffect = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rooTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />

                                            {/* Quà vật lý */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà vật lý</label>
                                                </div>

                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='drgfTop2' id="rgfTop2"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drgfTop2"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            realGifts && realGifts.map((value) => (
                                                                <option name={value.name} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>

                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[1].realGift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[1].realGift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[1].realGift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rgfTop2").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />
                                        </div>

                                        <br /><br />
                                        <div id="giftsTop3" className='border border-primary'>
                                            <h4>Quà Top 3</h4>

                                            {/* CUP, Quà, Khung Bài thu, Huy hiệu Bài thu */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>CUP</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà</label>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <label>Khung Bài thu</label>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                { competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <label>Huy hiệu Bài thu</label>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                <div className="col-2">
                                                    <label>Hiệu ứng khi hát</label>
                                                </div>
                                         
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcupTop3' id="cupTop3"
                                                        placeholder='Chọn Cup'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcupTop3"
                                                    >
                                                        <option value="">Chọn Cup</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dgifTop3' id="gifTop3"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dgifTop3"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option name={value.url} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                {
                                                    competition && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <input list='dfraTop3' id="fraTop3"
                                                            placeholder='Chọn Khung trang trí bài thu'
                                                            onChange={this.showImgPreview} />
                                                        <datalist
                                                            id="dfraTop3"
                                                        >
                                                            <option value="">Chọn khung</option>
                                                            {
                                                                frameDecoration && frameDecoration.map((value) => (
                                                                    <option key={value.id} value={value.name} >
                                                                    </option>
                                                                ))
                                                            }
                                                        </datalist>
                                                    </div> : <div className="col-2"></div>

                                                }
                                                { competition && competition.idEvent == "TheVoice" ?
                                       
                                                        <div className="col-2">
                                                            <input list='dmedTop3' id="medTop3"
                                                                placeholder='Chọn huy hiệu trang trí bài thu'
                                                                onChange={this.showImgPreview} />
                                                            <datalist
                                                                id="dmedTop3"
                                                            >
                                                                <option value="">Chọn huy hiệu</option>
                                                                {
                                                                    medalDecoration && medalDecoration.map((value) => (
                                                                        <option key={value.id} value={value.name} >
                                                                        </option>
                                                                    ))
                                                                }
                                                            </datalist>
                                                        </div> : <div className="col-2"></div>
                                          
                                                }

                                                <div className="col-2">
                                                    <input list='dsinTop3' id="sinTop3"
                                                        placeholder='Chọn Hiệu ứng Hát'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dsinTop3"
                                                    >
                                                        <option value="">Chọn Hiệu ứng hát</option>
                                                        {
                                                            singEffects && singEffects.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                            </div>
                                            {/* XEM TRƯỚC ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].cup) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].cup.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].cup = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cupTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].gift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].gift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].gift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("gifTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].recordingFrame && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[2].recordingFrame.thumbnailUrl}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[2].recordingFrame = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("fraTop3").value = "";
                                                            }}
                                                        >x</button>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].recordingMedal && competition.idEvent == "TheVoice" ?
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[2].recordingMedal.url}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[2].recordingMedal = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("medTop3").value = "";
                                                            }}
                                                        >x</button>
                                                    </div> : <div className="col-2"></div>
                                                }
                                                {
                                                    competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].singEffects &&
                                                    <div className="col-2">
                                                        <img width={50} height={50} src={competition.giftTheVoiceRound2[2].singEffects.previewImg}>
                                                        </img>
                                                        <button className='btn btn-sm btn-outline-danger'
                                                            onClick={() => {
                                                                let competitionBefore = competition;
                                                                competitionBefore.giftTheVoiceRound2[2].singEffects = null;
                                                                this.setState({
                                                                    competition: competitionBefore
                                                                })
                                                                document.getElementById("sinTop3").value = "";
                                                            }}
                                                        >x</button>
                                                    </div>

                                                }
                                                
                                            </div>
                                            <br />
                                            {/* Avatar, Khung bình luận, Thẻ cá nhân, Trang trí cá nhân, Hiệu ứng vào phòng */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Avatar</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Khung bình luận</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Thẻ cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Trang trí cá nhân</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Hiệu ứng vào phòng</label>
                                                </div>
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='davaTop3' id="avaTop3"
                                                        placeholder='Chọn Khung'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="davaTop3"
                                                    >
                                                        <option value="">Chọn Khung</option>
                                                        {
                                                            avas && avas.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcmtTop3' id="cmtTop3"
                                                        placeholder='Chọn hiệu ứng bình luận'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcmtTop2"
                                                    >
                                                        <option value="">Chọn hiệu ứng bình luận</option>
                                                        {
                                                            commentFrames && commentFrames.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dprsTop3' id="prsTop3"
                                                        placeholder='Chọn thẻ cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dprsTop3"
                                                    >
                                                        <option value="">Chọn thẻ cá nhân</option>
                                                        {
                                                            personalCards && personalCards.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dudcTop3' id="udcTop3"
                                                        placeholder='Chọn trang trí cá nhân'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dudcTop3"
                                                    >
                                                        <option value="">Chọn trang trí cá nhân</option>
                                                        {
                                                            userDecorations && userDecorations.map((value) => (
                                                                <option name={value.url} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='drooTop3' id="rooTop3"
                                                        placeholder='Chọn Hiệu ứng vào phòng'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drooTop3"
                                                    >
                                                        <option value="">Chọn Hiệu ứng vào phòng</option>
                                                        {
                                                            roomEntryEffects && roomEntryEffects.map((value) => (
                                                                <option key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].avatarFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].avatarFrame.previewImg}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].avatarFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("avaTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].commentFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].commentFrame.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].commentFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cmtTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].personalCard) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].personalCard.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].personalCard = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("prsTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].userDecoration) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].userDecoration.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].userDecoration = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("udcTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].roomEntryEffect) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].roomEntryEffect.resourceUrl}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].roomEntryEffect = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rooTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />

                                            {/* Quà vật lý */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà vật lý</label>
                                                </div>

                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='drgfTop3' id="rgfTop3"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drgfTop3"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            realGifts && realGifts.map((value) => (
                                                                <option name={value.name} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>

                                            </div>
                                            {/* XEM TRƯỚC =================*/}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[2].realGift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[2].realGift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[2].realGift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rgfTop3").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />
                                        </div>

                                        <br /><br />
                                        <div id="giftsTop4" className='border border-primary'>
                                            <h4>Quà Khuyến khích</h4>

                                            {/* CUP, Quà, Avatar */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <label>CUP</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Avatar</label>
                                                </div>
                                                <div className="col-2">
                                                    <label>Quà vật lý</label>
                                                </div>
                                            </div>
                                            {/* CHỌN ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    <input list='dcupTop4' id="cupTop4"
                                                        placeholder='Chọn Cup'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dcupTop4"
                                                    >
                                                        <option value="">Chọn Cup</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='dgifTop4' id="gifTop4"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="dgifTop4"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            cups && cups.map((value) => (
                                                                <option name={value.url} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }

                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='davaTop4' id="avaTop4"
                                                        placeholder='Chọn Khung'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="davaTop4"
                                                    >
                                                        <option value="">Chọn Khung</option>
                                                        {
                                                            avas && avas.map((value) => (
                                                                <option name={value.previewImg} key={value._id} value={value._id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>
                                                <div className="col-2">
                                                    <input list='drgfTop4' id="rgfTop4"
                                                        placeholder='Chọn Quà'
                                                        onChange={this.showImgPreview} />
                                                    <datalist
                                                        id="drgfTop4"
                                                    >
                                                        <option value="">Chọn Quà</option>
                                                        {
                                                            realGifts && realGifts.map((value) => (
                                                                <option name={value.name} key={value.id} value={value.id} >
                                                                </option>
                                                            ))
                                                        }
                                                    </datalist>
                                                </div>

                                            </div>
                                            {/* XEM TRƯỚC ================= */}
                                            <div className="row mb-2">
                                                <div className="col-1">
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[3].cup) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[3].cup.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[3].cup = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("cupTop4").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[3].gift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[3].gift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[3].gift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("gifTop4").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[3].avatarFrame) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[3].avatarFrame.previewImg}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[3].avatarFrame = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("avaTop4").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                                <div className="col-2">
                                                    {
                                                        (competition && competition.giftTheVoiceRound2 && competition.giftTheVoiceRound2[3].realGift) ? (
                                                            <>
                                                                <img width={50} height={50} src={competition.giftTheVoiceRound2[3].realGift.url}>
                                                                </img>
                                                                <button className='btn btn-sm btn-outline-danger'
                                                                    onClick={() => {
                                                                        let competitionBefore = competition;
                                                                        competitionBefore.giftTheVoiceRound2[3].realGift = null;
                                                                        this.setState({
                                                                            competition: competitionBefore
                                                                        })
                                                                        document.getElementById("rgfTop4").value = "";
                                                                    }}
                                                                >x</button>
                                                            </>
                                                        ) : ''
                                                    }
                                                </div>
                                            </div>
                                            <br />


                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {loading ?
                                    (
                                        <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Xác nhận...
                                        </button>
                                    ) :
                                    (
                                        <button style={{ width: "120px" }} type="button" className="btn btn-red" onClick={this.saveCompetition}>Xác nhận</button>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
